import React, { Component } from "react";
import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromRaw,
  convertFromHTML,
  RichUtils,
} from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import $, { event } from "jquery";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import ReactPlayer from "react-player";
import ReactAudioPlayer from "react-audio-player";
import { ToastContainer, toast } from "react-toastify";
import { Progress } from "react-sweet-progress";
import "react-sweet-progress/lib/style.css";
import { tr } from "date-fns/locale";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import cssu
import JSZip from "jszip";
import { saveAs } from "file-saver";
import BrowseContent from "./BrowseFromAdminContent";
import TranslationPanel from "./TranslationPanel";
import MoveToFolderPanel from "./MoveToFolderPanel";
import EmojiPickerButton from "./EmojiPickerButton";
import FileChooser from "./FileChooser";

export default class ContentLibraryForTreatment extends Component {
  constructor() {
    super();

    window.ContentLibraryController = this;

    this.dialogClose = () => {
      this.setState({
        hideDeletePopup: false,
        hideDeletePublishPopup: false,
        hideDeleteUnpublishPopup: false,
      });
    };
    this.DeletedialogClose = () => {
      this.setState({ hideTextAreaPopup: false });
    };

    this.settings = { effect: "Zoom", duration: 400, delay: 0 };

    //for delete dialog component ok click
    this.buttons = [
      {
        buttonModel: {
          content: "Yes",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: (props) => {
          if (this.state.type == "content") {
            this.deleteContent(this.state.propsId);
          } else {
            this.deleteFolder(this.state.propsId);
          }
          this.setState({ disabled: false });
        },
      },
      {
        buttonModel: {
          content: "No",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({
            hideDeletePopup: false,
            disabled: false,
          });
        },
      },
    ];

    //for delete dialog component ok click
    this.publishButtons = [
      {
        buttonModel: {
          content: "Yes",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: (props) => {
          this.publish();
        },
      },
      {
        buttonModel: {
          content: "No",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({
            hideDeletePublishPopup: false,
            disabled: false,
          });
        },
      },
    ];

    this.unpublishButtons = [
      {
        buttonModel: {
          content: "Yes",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: (props) => {
          this.unPublish();
        },
      },
      {
        buttonModel: {
          content: "No",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({
            hideDeleteUnpublishPopup: false,
            disabled: false,
          });
        },
      },
    ];

    //for delete success
    this.deleteSuccessbuttons = [
      {
        buttonModel: {
          content: "Ok",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: (props) => {
          this.dialogInstance.hide();
          this.fetchContent();
          this.setState({ disabled: false });
        },
      },
    ];

    this.state = {
      newAdminContent: new Map(),
      currentProviderParentFolderId: "00000000-0000-0000-0000-000000000000",
      propsTreatmetId: "",
      providerContentUrl: "/content",
      adminContentUrl: "/admin-content",
      imageUrlUpload: false,
      dataStartedProcessing: false,
      disableSelectContentType: false,
      videoUrlUpload: false,
      editVideoUrlUpload: false,
      audioUrlUpload: false,
      showProgressBar: false,
      progressStatus: null,
      percentage: 0,
      hideChoseFile: false,
      docCharacterCount: 0,
      errorMsg: "",
      selectedOption: "uploadFileContent",
      uploadURLContent: false,
      imgContent: "",
      fileContentUpload: false,
      iconFileUpload: false,
      type: "",
      contentId: "",
      translationFor: null,
      moving: null,
      editorState: EditorState.createEmpty(),
      existingContentInfo: {
        documentSections: [],
        subFolderList: [],
        folderTitle: "Home",
      },
      folderId: "00000000-0000-0000-0000-000000000000",
      folderPathName: "Home",
      showNoData: false,
      addedFolderInfo: [],
      iconFile: "",
      iconFileNameDisplay: "",
      iconFileName: "",
      iconImage: false,
      imageContentType: false,
      videoContentType: false,
      audioContentType: false,
      textContentType: true,
      showAddFolderOverLay: false,
      showAddContentOverLay: false,
      documentList: [],
      showLoader: false,
      editedId: -1,
      languageList: [],
      language: "",
      hideDeletePopup: false,
      hideDeletePublishPopup: false,
      hideDeleteUnpublishPopup: false,
      published: false,
      disableUpload: false,
      disableDone: false,
      userRole: null,
      isSafari: false,
      folderPath: [
        {
          id: "00000000-0000-0000-0000-000000000000",
          label: "Home",
          depth: 0,
        },
      ],
    };
    this.userDetails = JSON.parse(localStorage.getItem("user_details"));
    this.onEditorStateChange = this.onEditorStateChange.bind(this);
    // this.setDomEditorRef = ref => this.domEditor = ref;
    // this.focus = () => this.domEditor.curent
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
    this.fileInput = [];
    this.newVersionInfo =
      "The content is published with the latest version.";
  }
  componentDidMount() {
    const browser = navigator.userAgent;
    if (browser.includes("Safari") && !browser.includes("Chrome")) {
      this.state.isSafari = true;
      this.setState(this.state);
    }
    var thisController = this;
    thisController.setState({ userRole: thisController.userDetails["userRole"] })
    setTimeout(() => {
      thisController.fetchContent();
    }, 300);
  }

  handleBrowseModalClose = () => {
    const { newAdminContent } = this.state;
    newAdminContent.clear();
    this.setState({ showBrowseModal: false, newAdminContent });
  };

  handleOpenBrowseModal = () => {
    this.setState({ showBrowseModal: true });
  };

  handleChangeParentFolderId = (parentFolderId) => {
    console.log("called from child ");
    this.setState({ currentProviderParentFolderId: parentFolderId });
  };

  handleAddContentData = (type, id) => {
    // Perform operations on contentMap based on 'type' and 'id'
    const { newAdminContent } = this.state;
    // console.log(
    //   this.state.currentProviderParentFolderId + "---->" + id + " type: " + type
    // );
    if (!newAdminContent.has(this.state.currentProviderParentFolderId)) {
      newAdminContent.set(this.state.currentProviderParentFolderId, new Map());
    }

    const content = newAdminContent.get(
      this.state.currentProviderParentFolderId
    );
    if (content.has(type) === false) {
      content.set(type, new Set());
    }
    // console.log(content);
    if (content.get(type).has(id)) {
      content.get(type).delete(id);
    } else {
      content.get(type).add(id);
    }

    this.setState({ newAdminContent });
    // console.log(contentMap);
    // Perform operations on contentMap based on 'type' and 'id'
  };

  checkForEmpty = () => {
    const { newAdminContent } = this.state;
    let isEmpty = true;
    for (const key of newAdminContent.keys()) {
      const innerMap = newAdminContent.get(key);
      for (let type of innerMap.keys()) {
        const setValues = innerMap.get(type);
        if (setValues.size > 0) {
          isEmpty = false;
          return isEmpty;
        }
      }
    }
    return isEmpty;
  }

  handleRemoveContentData = (type, id) => {

    // find the folder id and delete if present
    const { newAdminContent } = this.state;
    for (const key of newAdminContent.keys()) {
      const innerMap = newAdminContent.get(key);

      const setValues = innerMap.get(type);
      if (setValues && setValues.has(id)) {
        setValues.delete(id);
      }
    }
    this.setState({ newAdminContent });

  }

  startUpdatingFolder = (el, i) => {
    this.state.iconImage = true;
    this.state.showAddFolderOverLay = true;
    this.state.errorMsg = "";
    document.getElementById("labelId").value = el.label;
    document.getElementById("descriptionId").value = el.description;
    // Drop any icon picked while editing the previous folder
    document.getElementById("selectedMediaContent").value = "";
    this.state.iconFile = ``;
    this.state.iconFileUpload = false;
    // this.state.iconFileNameDisplay = URL.createObjectURL(new Blob([el.icon]));
    this.state.iconFileNameDisplay = el.icon;
    // Icons uploaded before file names were stored have no name to show
    this.state.iconFileName = el.iconFileName || (el.icon || el.iconMediaId ? "Current icon" : "");
    this.state.updatingFolder = true;
    this.state.idToBeUpdated = el.id;

    this.setState(this.state);
  };

  startUpdatingSection = (el, i) => {
    // Allow editing published content directly
    this.openUpdateSectionEditor(el, i);
  };

  openUpdateSectionEditor = (el, i) => {
    this.state.editedId = "-1";
    this.state.showAddContentOverLay = true;
    this.state.disableSelectContentType = true;
    this.state.errorMsg = "";
    this.state.disableDone = false;
    this.state.mediaId = el.mediaId;
    this.state.idToBeUpdated = el.id;
    this.state.contentType = el.type;
    //   htmlToDraft(convertToRaw(this.state.editorState.getCurrentContent())) = el.textContent;
    if (el.type == "TEXT") {
      const contentBlock = htmlToDraft(el.textContent);
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks,
        contentBlock.entityMap
      );
      this.state.editorState = EditorState.createWithContent(contentState);
      document.getElementById("contentTypeId").value = "TEXT";
      this.state.textContentType = true;
      this.state.imageContentType = false;
      this.state.videoContentType = false;
      this.state.audioContentType = false;
    } else if (el.type == "IMAGE") {
      document.getElementById("contentTypeId").value = "IMAGE";
      // document.getElementById("imageCaptionId").value = el.caption;
      if (el.mediaId == null) {
        this.state.selectedOption = "uploadURLContent";
        this.state.uploadURLContent = true;
        document.getElementById("imageUrlCaptionId").value = el.caption;
        document.getElementById("imageContentUrl").value = el.mediaUrl;
        document.getElementById("imageCaptionId").value = "";
        this.state.imageUrlUpload = true;
        this.setState(this.state);
      }
      if (el.mediaId != null) {
        this.state.selectedOption = "uploadFileContent";
        document.getElementById("imageCaptionId").value = el.caption;
        document.getElementById("imageUrlCaptionId").value = "";
        this.state.uploadURLContent = false;
        this.setState(this.state);
      }
      this.state.textContentType = false;
      this.state.imageContentType = true;
      this.state.videoContentType = false;
      this.state.audioContentType = false;
    } else if (el.type == "VIDEO") {
      document.getElementById("contentTypeId").value = "VIDEO";
      if (el.mediaId == null) {
        this.state.selectedOption = "uploadURLContent";
        this.state.uploadURLContent = true;
        document.getElementById("videoUrlCaptionId").value = el.caption;
        document.getElementById("videoContentUrl").value = el.mediaUrl;
        document.getElementById("videoCaptionId").value = "";
        this.state.videoUrlUpload = true;
        this.setState(this.state);
      }
      if (el.mediaId != null) {
        this.state.selectedOption = "uploadFileContent";
        document.getElementById("videoCaptionId").value = el.caption;
        document.getElementById("videoUrlCaptionId").value = "";

        this.state.uploadURLContent = false;

        this.setState(this.state);
      }
      this.state.textContentType = false;
      this.state.imageContentType = false;
      this.state.videoContentType = true;
      this.state.audioContentType = false;
    } else if (el.type == "AUDIO") {
      document.getElementById("contentTypeId").value = "AUDIO";
      if (el.mediaId == null) {
        this.state.selectedOption = "uploadURLContent";
        this.state.uploadURLContent = true;
        document.getElementById("audioUrlCaptionId").value = el.caption;
        document.getElementById("audioContentUrl").value = el.mediaUrl;
        document.getElementById("audioCaptionId").value = "";
        this.state.audioUrlUpload = true;
        this.setState(this.state);
      }
      if (el.mediaId != null) {
        this.state.selectedOption = "uploadFileContent";
        document.getElementById("audioCaptionId").value = el.caption;
        document.getElementById("audioUrlCaptionId").value = "";
        this.state.uploadURLContent = false;
        this.setState(this.state);
      }
      this.state.textContentType = false;
      this.state.imageContentType = false;
      this.state.videoContentType = false;
      this.state.audioContentType = true;
    }
    this.state.updatingContent = true;
    this.state.idToBeUpdated = el.id;
    this.setState(this.state);
  };

  startAddingFolder = () => {
    this.state.iconImage = false;
    document.getElementById("labelId").value = "";
    document.getElementById("descriptionId").value = "";
    document.getElementById("selectedMediaContent").value = "";
    this.state.showAddFolderOverLay = true;
    this.state.updatingFolder = false;
    this.state.iconFile = ``;
    this.state.errorMsg = "";
    this.state.iconFileNameDisplay = "";
    this.state.iconFileName = "";
    this.setState(this.state);
  };

  startAddingContent = () => {
    this.openAddContentEditor();
  };

  openAddContentEditor = () => {
    document.getElementById("contentTypeId").value = "TEXT";
    this.state.disableSelectContentType = false;
    this.state.percentage = 0;
    this.state.showProgressBar = false;
    this.state.textContentType = true;
    this.state.imageContentType = false;
    this.state.videoContentType = false;
    this.state.audioContentType = false;
    this.state.disableDone = false;
    this.state.contentType = "TEXT";
    this.state.updatingContent = false;
    this.state.showAddContentOverLay = true;
    this.state.editorState = EditorState.createEmpty();
    this.state.errorMsg = "";
    this.state.idToBeUpdated = false;
    document.getElementById("imageContentUrl").value = "";
    document.getElementById("videoContentUrl").value = "";
    document.getElementById("audioContentUrl").value = "";
    document.getElementById("imageCaptionId").value = "";
    document.getElementById("videoCaptionId").value = "";
    document.getElementById("audioCaptionId").value = "";

    document.getElementById("imageUrlCaptionId").value = "";
    document.getElementById("videoUrlCaptionId").value = "";
    document.getElementById("audioUrlCaptionId").value = "";

    document.getElementById("imageContentId").value = null;
    document.getElementById("videoContentId").value = null;
    document.getElementById("audioContentId").value = null;
    this.setState(this.state);
  };

  onPreviewButtonClick = () => {
    //document.getElementById("contentId").value = "";
    localStorage.setItem("treatmentId", this.props.location.state.treatmentId);
    localStorage.setItem("parentFolderId", this.state.folderId);
    this.state.showpreviewModeOverLay = true;
    var previewIframe = document.getElementById("previewIframe");
    previewIframe.src = previewIframe.src;
    this.setState(this.state);
  };

  handleSubmitButtonClick = (event) => {
    event.preventDefault();
    let element = document.getElementById("uploadFile");
    element.click();
  };

  onContentTypeChange = (e) => {
    this.state.errorMsg = "";
    this.state.contentType = e.target.value;
    document.getElementById("imageContentUrl").value = "";
    document.getElementById("videoContentUrl").value = "";
    document.getElementById("audioContentUrl").value = "";
    if (e.target.value == "TEXT") {
      this.state.textContentType = true;
      this.state.imageContentType = false;
      this.state.videoContentType = false;
      this.state.audioContentType = false;
    } else if (e.target.value == "IMAGE") {
      this.state.textContentType = false;
      this.state.imageContentType = true;
      this.state.videoContentType = false;
      this.state.audioContentType = false;
    } else if (e.target.value == "VIDEO") {
      this.state.textContentType = false;
      this.state.imageContentType = false;
      this.state.videoContentType = true;
      this.state.audioContentType = false;
    } else if (e.target.value == "AUDIO") {
      this.state.textContentType = false;
      this.state.imageContentType = false;
      this.state.videoContentType = false;
      this.state.audioContentType = true;
    }
    this.setState(this.state);
  };
  closeAddFolderoverLay = () => {
    this.state.showAddFolderOverLay = false;
    this.state.disableUpload = false;
    this.setState(this.state);
  };
  closeAddContentOverLay = () => {
    this.state.showAddContentOverLay = false;
    this.setState(this.state);
  };
  closepreviewModeOverLay = () => {
    this.state.showpreviewModeOverLay = false;
    this.setState(this.state);
    var iframe = document.getElementById('previewIframe');
    iframe.contentWindow.postMessage('stopVideo', '*');
  };
  fetchFolder() {
    var fetchController = this;
    $.ajax({
      url: "/my-jeeva-api/folder",

      method: "GET",
      data: {
        parentId: fetchController.state.folderId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success == true) {
          if (res.result.length == 0) {
            fetchController.state.showNoData = true;
            fetchController.state.addedFolderInfo = res.result;
            fetchController.setState(fetchController.state);
          } else {
            fetchController.state.showNoData = false;
            fetchController.state.addedFolderInfo = res.result;
            fetchController.state.showAddFolderOverLay = false;
            fetchController.setState(fetchController.state);
          }
        }
      },
    });
  }


  saveFolder = () => {
    this.state.editedId = "-1";
    this.state.disableUpload = true;
    this.setState(this.state);
    var saveController = this;
    var label = document.getElementById("labelId").value.trim();
    var description = document.getElementById("descriptionId").value;
    var icon = saveController.state.iconFile;
    var labelPattern = new RegExp(
      /^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?']+$/
    );
    var formData = new FormData();
    formData.append("label", label);
    formData.append("description", description);
    formData.append("icon", icon);
    formData.append("parentId", saveController.state.folderId);
    formData.append(
      "contentId",
      saveController.state.existingContentInfo.contentId
    );
    if (icon != undefined && icon != "") {
      var fileExtension = icon.name.split(".").pop().toLowerCase();
    }

    if (label == "" || icon == `` || icon == undefined) {
      saveController.state.disableUpload = false;
      saveController.state.errorMsg = "*Please fill all the fields";
      saveController.setState(saveController.state);
    } else if (!labelPattern.test(label)) {
      saveController.notifyImproperLabel();
      saveController.state.disableUpload = false;
      saveController.setState(saveController.state);
    } else if (!["jpg", "jpeg", "png", "gif"].includes(fileExtension)) {
      saveController.state.disableUpload = false;
      saveController.state.errorMsg = "*Please provide a valid image icon";
      saveController.setState(saveController.state);
    } else {
      var timer = setInterval(function () {
        clearTimeout(timer);
        formData.append("libraryModuleId", saveController.state.existingContentInfo.contentId);
        $.ajax({
          url: "/my-jeeva-api/library-module-admin/folder",
          method: "POST",
          data: formData,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
          processData: false,
          contentType: false,
          success: function (res) {
            if (res.success === true) {
              saveController.setState({
                iconFileUpload: false,
              })
              saveController.fetchContent();
            } else {
              saveController.notifyFailedResponse(res.result);
            }
          },
          error: function (xhr) {
            if (xhr.status == 401) {
              window.location.href = "";
            }
          },
        });
      }, 2000);
    }
  };
  notifyImproperLabel() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please provide a valid folder name
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyEmptyFields() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill all the fields
      </b>,
      {
        position: "top-center",
      }
    );
  }

  updateFolder = (index) => {
    this.state.disableUpload = true;
    this.setState(this.state);
    var saveController = this;
    var label = document.getElementById("labelId").value.trim();
    var description = document.getElementById("descriptionId").value;
    // var icon = saveController.state.iconFile;
    var labelPattern = new RegExp(
      /^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?']+$/
    );
    var formData = new FormData();
    formData.append("id", saveController.state.idToBeUpdated);
    formData.append("label", label);
    formData.append("description", description);
    if (this.state.iconFileUpload) {
      formData.append("icon", saveController.state.iconFile);
      this.state.iconFileUpload = false;
      this.setState(this.state);
    }
    if (this.state.iconFile != undefined && this.state.iconFile != "") {
      var iconFileExtension = this.state.iconFile.name
        .split(".")
        .pop()
        .toLowerCase();
    }
    // if( this.state.iconFile == undefined ||  this.state.iconFile == "" ) {
    //   formData.append("icon", saveController.state.iconFile);
    // }
    // formData.append("icon", icon);
    if (label == "") {
      saveController.state.disableUpload = false;
      saveController.state.errorMsg = "*Please fill all the fields";
      saveController.setState(saveController.state);
    } else if (!labelPattern.test(label)) {
      saveController.notifyImproperLabel();
      saveController.state.disableUpload = false;
      saveController.setState(saveController.state);
    } else if (
      this.state.iconFile != undefined &&
      this.state.iconFile != "" &&
      !["jpg", "jpeg", "png", "gif"].includes(iconFileExtension)
    ) {
      saveController.state.disableUpload = false;
      saveController.state.errorMsg = "*Please provide a valid image icon";
      saveController.setState(saveController.state);
    } else {
      var timer = setInterval(function () {
        clearTimeout(timer);
        $.ajax({
          url: "/my-jeeva-api/library-module-admin/folder/" + saveController.state.idToBeUpdated,

          method: "PATCH",
          data: formData,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
          processData: false,
          contentType: false,
          success: function (res) {
            if (res.success === true) {
              saveController.fetchContent();
            } else {
              saveController.notifyFailedResponse(res.result);
            }
          },
          error: function (xhr) {
            if (xhr.status == 401) {
              window.location.href = "";
            }
          },
        });
      }, 2000);
    }
  };

  addNewAdminContent = () => {
    const { newAdminContent } = this.state;
    const data = {};
    console.log(" new admin content with sets: ", newAdminContent);
    // need to convert the sets to arrays before sending to server

    var addNewAdminContentController = this;
    const newAdminContentWithArrays = {};

    for (const key of newAdminContent.keys()) {
      const innerMap = newAdminContent.get(key);

      const newInnerMap = {};

      for (const type of innerMap.keys()) {
        const setValues = innerMap.get(type);
        const arrayValues = Array.from(setValues);
        newInnerMap[type] = arrayValues;
      }

      newAdminContentWithArrays[key] = newInnerMap;
    }
    console.log("New Admin Content contains: ", newAdminContentWithArrays);
    data["sourceContentId"] = this.state.contentId;
    data["newContentMap"] = newAdminContentWithArrays;

    console.log(" entire object looks like this: ", data);

    $.ajax({
      url: "/my-jeeva-api/clone-new-admin-content",

      method: "POST",
      data: JSON.stringify(data),
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      success: function (res) {
        if (res.success === true) {
          addNewAdminContentController.setState({ showBrowseModal: false });
          addNewAdminContentController.fetchContent();
          addNewAdminContentController.setState({ newAdminContent: new Map() });
          addNewAdminContentController.notifyContentCopied();
        } else {
          addNewAdminContentController.notifyFailedResponse(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "";
        }
      },
    });
  };

  fetchContent(updateFolderPath) {
    var fetchController = this;
    var scopeGroups = [];
    localStorage.setItem("treatmentId", this.props.location.state.treatmentId);
    scopeGroups.push(this.props.location.state.treatmentId);
    $.ajax({
      url: "/my-jeeva-api/library-module-admin/content",
      async: true,
      method: "GET",
      data: {
        scopeGroup: fetchController.props.location.state.treatmentId,
        scopeGroups: JSON.stringify(scopeGroups),
        scope: "TREATMENT",
        parentFolderId: fetchController.state.folderId,
      },
      success: function (res) {
        if (res.success == true) {
          console.log("The content is fetched : ", res.result);
          ["imageContentUrl", "videoContentUrl", "audioContentUrl", "imageCaptionId", "videoCaptionId", "audioCaptionId", "imageContentId",
            "videoContentId", "audioContentId"
          ].forEach(id => {
            const el = document.getElementById(id);
            if (el) el.value = "";
          });

          ["imageContentId", "videoContentId", "audioContentId"].forEach(id => {
            const el = document.getElementById(id);
            if (el) el.value = null;
          });

          // document.getElementById("imageContentUrl")?.value = "";
          // document.getElementById("videoContentUrl")?.value = "";
          // document.getElementById("audioContentUrl")?.value = "";
          // document.getElementById("imageCaptionId")?.value = "";
          // document.getElementById("videoCaptionId")?.value = "";
          // document.getElementById("audioCaptionId")?.value = "";
          // document.getElementById("imageContentId")?.value = null;
          // document.getElementById("videoContentId")?.value = null;
          // document.getElementById("audioContentId")?.value = null;
          fetchController.state.disableUpload = false;
          fetchController.state.contentId = res.result.contentId;
          fetchController.setState(fetchController.state);

          fetchController.state.fileContent = undefined;
          if (res.result.length == 0) {
            fetchController.state.showNoData = true;
            fetchController.state.existingContentInfo = res.result;
            fetchController.setState(fetchController.state);
          } else {
            fetchController.state.fileContentUpload = false;
            // fetchController.state.iconFileUpload=false
            fetchController.state.imageUrlUpload = false;
            fetchController.state.videoUrlUpload = false;
            fetchController.state.editVideoUrlUpload = false;
            fetchController.state.audioUrlUpload = false;
            fetchController.state.showNoData = false;
            fetchController.state.existingContentInfo = res.result;
            fetchController.state.showAddContentOverLay = false;
            fetchController.state.showAddFolderOverLay = false;
            fetchController.state.showpreviewModeOverLay = false;
            fetchController.state.showProgressBar = false;
            fetchController.state.published = res.result.published;
            console.log(
              "The state of published in fetchContent :" +
              fetchController.state.published
            );
            fetchController.maxOrder = res.result.maxOrder;
            if (updateFolderPath) {
              var folderPathIdList = fetchController.state.folderPath.map(
                (fp) => {
                  return fp.id;
                }
              );
              if (!folderPathIdList.includes(fetchController.state.folderId)) {
                fetchController.state.folderPath.push({
                  id: fetchController.state.folderId,
                  label: res.result.folderTitle,
                  depth: fetchController.state.folderPath.length,
                });
              }
            }
            fetchController.setState(fetchController.state);
          }
        }
      },
    });
  }

  fetchStream(mediaId) {
    var fetchController = this;

    $.ajax({
      url: "/my-jeeva-api/stream",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        mediaId: mediaId,
      },
      success: function (res) {
        if (res.success == true) {
          console.log("done with streaming");
        }
      },
    });
  }
  fetchMedia(mediaId) {
    var fetchController = this;

    $.ajax({
      url: "/my-jeeva-api/media",

      method: "GET",

      data: {
        mediaId: mediaId,
      },
      success: function (res) {
        fetchController.state.mediaUrl = res;
        fetchController.setState(fetchController.state);
      },
    });
  }

  saveContentFromUrl = () => {
    if (this.state.idToBeUpdated !== false) {
      this.state.editedId = this.state.idToBeUpdated;
    } else {
      this.state.editedId = "-1";
    }
    this.setState(this.state);
    var thisController = this;
    thisController.state.showProgressBar = true;
    var contentData = {};
    if (thisController.state.contentType == "TEXT") {
      if (thisController.state.docCharacterCount == 0) {
        thisController.state.errorMsg = "*Please fill the text field";
        thisController.setState(thisController.state);
        return;
      } else {
        contentData = {
          textContent: draftToHtml(
            convertToRaw(thisController.state.editorState.getCurrentContent())
          ),
          type: thisController.state.contentType,
          folderId: thisController.state.folderId,
          contentId: thisController.state.existingContentInfo.contentId,
        };
      }
    } else {
      var mediaUrl;
      thisController.state.hideChoseFile = true;
      var imageContentUrl = document.getElementById("imageContentUrl").value;
      var videoContentUrl = document.getElementById("videoContentUrl").value;
      var audioContentUrl = document.getElementById("audioContentUrl").value;
      var captionPattern = new RegExp(
        /^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/
      );
      var caption;
      var imgCaption = document
        .getElementById("imageUrlCaptionId")
        .value.trim();
      var videoCaption = document
        .getElementById("videoUrlCaptionId")
        .value.trim();
      var audioCaption = document
        .getElementById("audioUrlCaptionId")
        .value.trim();

      if (thisController.state.contentType == "IMAGE") {
        if (imageContentUrl == "" || imgCaption == "") {
          thisController.state.errorMsg = "*Please fill all the fields";
          thisController.setState(thisController.state);
          return;
        } else if (!captionPattern.test(imgCaption)) {
          thisController.notifyImproperCaption();
        } else {
          caption = imgCaption;
          mediaUrl = document.getElementById("imageContentUrl").value;
          contentData = {
            mediaUrl: mediaUrl,
            type: thisController.state.contentType,
            folderId: thisController.state.folderId,
            contentId: thisController.state.existingContentInfo.contentId,
            caption: caption,
          };
        }
      }

      if (thisController.state.contentType == "VIDEO") {
        if (videoContentUrl == "" || videoCaption == "") {
          thisController.state.disableDone = false;
          thisController.state.errorMsg = "*Please fill all the fields";
          thisController.setState(thisController.state);
          return;
        } else if (!captionPattern.test(videoCaption)) {
          thisController.state.disableDone = false;
          thisController.setState(thisController.state);
          thisController.notifyImproperCaption();
        } else {
          caption = videoCaption;
          mediaUrl = document.getElementById("videoContentUrl").value;
          contentData = {
            mediaUrl: mediaUrl,
            type: thisController.state.contentType,
            folderId: thisController.state.folderId,
            contentId: thisController.state.existingContentInfo.contentId,
            caption: caption,
          };
        }
      }
      if (thisController.state.contentType == "AUDIO") {
        if (audioContentUrl == "" || audioCaption == "") {
          thisController.state.errorMsg = "*Please fill all the fields";
          thisController.setState(thisController.state);
          return;
        } else if (!captionPattern.test(audioCaption)) {
          thisController.notifyImproperCaption();
        } else {
          caption = audioCaption;
          mediaUrl = document.getElementById("audioContentUrl").value;
          contentData = {
            mediaUrl: mediaUrl,
            type: thisController.state.contentType,
            folderId: thisController.state.folderId,
            contentId: thisController.state.existingContentInfo.contentId,
            caption: caption,
          };
        }
      }
    }

    if (thisController.state.contentType !== "TEXT") {
      const mediaUrltoCheck = contentData.mediaUrl;
      var fileExtension = "";
      if (mediaUrltoCheck) {
        fileExtension = mediaUrltoCheck.split(".").pop().toLowerCase();
      }
      const youtubeVideoPattern = new RegExp(
        /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/
      );
      const onlineMusicAppPattern = new RegExp(
        /^(?:https?:\/\/)?(?:www\.)?(?:soundcloud\.com|snd\.sc|spotify\.com|open\.spotify\.com|music\.apple\.com|youtu(?:be)?\.com|youtu\.be)\/.*$/i
      );
      const imageUrlPattern = new RegExp(
        /^https?:\/\/.+\.(jpg|jpeg|png|gif)$/i
      );
      // console.log(imageUrl.split(":")[1].split(";")[0].split("/")[1]);
      console.log(
        "This the youtube url: " + youtubeVideoPattern.test(mediaUrltoCheck)
      );
      console.log(
        "This is online Music app url " +
        onlineMusicAppPattern.test(mediaUrltoCheck)
      );

      if (
        (thisController.state.contentType === "IMAGE" &&
          !["jpg", "jpeg", "png", "gif"].includes(fileExtension) &&
          !imageUrlPattern.test(mediaUrltoCheck)) ||
        (thisController.state.contentType === "VIDEO" &&
          !["mp4", "mov", "avi"].includes(fileExtension) &&
          !youtubeVideoPattern.test(mediaUrltoCheck)) ||
        (thisController.state.contentType === "AUDIO" &&
          !["mp3", "wav", "ogg", "mpeg"].includes(fileExtension) &&
          !onlineMusicAppPattern.test(mediaUrltoCheck))
      ) {
        thisController.state.errorMsg = "*Invalid content type.";
        thisController.state.disableDone = false;
        thisController.state.showProgressBar = false;
        thisController.setState(thisController.state);
        return;
      }
    }
    var sectionUpdateUrl = "/my-jeeva-api/library-module-admin/section?libraryModuleId=" + thisController.state.existingContentInfo.contentId + "&folderId=" + thisController.state.folderId;
    var sectionMethod = "POST";
    if (this.state.editedId != -1) {
      sectionUpdateUrl = "/my-jeeva-api/library-module-admin/section/" + this.state.editedId;
      sectionMethod = "PATCH";
      contentData.id = this.state.editedId;
    } else {
      if (!thisController.maxOrder) {
        thisController.maxOrder = 0;
      }
      contentData.order = thisController.maxOrder + 1;
    }
    if (sectionMethod == "PATCH") {
      thisController.state.errorMsg = "";
      thisController.setState(thisController.state);
    }

    $.ajax({
      url: sectionUpdateUrl,

      method: sectionMethod,
      async: true,
      data: JSON.stringify(contentData),
      cache: false,
      contentType: false,
      processData: false,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      success: function (res) {
        if (res.success === true) {
          thisController.fetchContent();
          thisController.state.showAddContentOverLay = false;
          thisController.state.editedId = "-1";
          thisController.state.disableDone == true;
          thisController.setState(thisController.state);
        } else {
          thisController.notifyFailedResponse(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "";
        }
      },
    });
    // window.location.reload();
  };

  notifyImproperField() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill all the fields
      </b>,
      {
        position: "top-center",
      }
    );
  }

  updateTextContent = (event) => {
    this.state.editedId = "-1";
    this.setState(this.state);
    var updateController = this;
    if (
      this.state.editorState.getCurrentContent().getPlainText().trim().length ==
      0
    ) {
      this.state.errorMsg = "*Please fill the text field";
      this.setState(this.state);
      return;
    }

    var contentData = {
      id: updateController.state.idToBeUpdated,
      textContent: draftToHtml(
        convertToRaw(this.state.editorState.getCurrentContent())
      ),
    };

    $.ajax({
      url: "/my-jeeva-api/library-module-admin/section/" + updateController.state.idToBeUpdated,

      method: "PATCH",
      data: JSON.stringify(contentData),
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },

      success: function (res) {
        if (res.success === true) {
          // updateController.notifyContentUpdated();
          updateController.fetchContent();
        } else {
          updateController.notifyFailedResponse(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "";
        }
      },
    });
  };

  onEditorStateChange = (editorState) => {
    const contentState = editorState.getCurrentContent();
    const oldContent = this.state.editorState.getCurrentContent();
    const contentStateAsRawObject = convertToRaw(contentState);
    console.log(contentStateAsRawObject);
    if (contentState.getPlainText().length > 1000) {
      const newEditorState = EditorState.moveFocusToEnd(
        EditorState.push(
          this.state.editorState,
          ContentState.createFromText(oldContent.getPlainText())
        )
      );
      this.setState({
        editorState: newEditorState,
        docCharacterCount: contentState.getPlainText().trim().length,
      });
    } else {
      var docCharacterCountLenght = contentState.getPlainText().trim().length;
      this.setState({
        editorState,
        docCharacterCount: docCharacterCountLenght,
      });
    }
    this.setState({ editorState });
    //  this.setState(this.state);
  };

  notifyFailedResponse(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  // Commented all notify functions to remove toast Messages.
  notifyFolderAdded() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Folder added successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyFolderUpdated() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Folder updated successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyContentUpdated() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Content updated successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyContentAdded() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Content added successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyContentCopied() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Content copied successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyEmptyFields() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill all the fields before saving
      </b>,
      {
        position: "top-center",
      }
    );
  }

  onChangeIconFile = (event) => {
    this.state.iconFile = event.target.files[0];
    this.state.iconFileUpload = true;
    this.setState(this.state);
  };
  onFileContentChange = (event) => {
    console.log("Number of file objects = " + event.target.files.length);
    this.state.fileContent = event.target.files[0];
    this.state.fileContentUpload = true;
    this.setState(this.state);
  };
  notifyImproperCaption() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please provide a valid caption
      </b>,
      {
        position: "top-center",
      }
    );
  }
  saveContentFromFileUpload = (event) => {
    this.state.dataStartedProcessing = true;
    this.state.editedId = "-1";
    this.setState(this.state);
    var thisController = this;
    thisController.state.disableDone = true;
    thisController.setState(thisController.state);
    var captionPattern = new RegExp(
      /^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/
    );
    var caption;
    var fileContentName;
    if (thisController.state.contentType == "IMAGE") {
      caption = document.getElementById("imageCaptionId").value;
    }

    if (thisController.state.contentType == "VIDEO") {
      caption = document.getElementById("videoCaptionId").value;
    }

    if (thisController.state.contentType == "AUDIO") {
      caption = document.getElementById("audioCaptionId").value;
    }

    if (caption == "" || thisController.state.fileContent == undefined) {
      thisController.state.errorMsg = "*Please fill all the fields";
      thisController.state.disableDone = false;
      thisController.setState(thisController.state);
    } else if (!captionPattern.test(caption)) {
      thisController.notifyImproperCaption();
      thisController.state.disableDone = false;
      thisController.setState(thisController.state);
    } else {
      const fileExtension = thisController.state.fileContent.name
        .split(".")
        .pop()
        .toLowerCase();

      var formData = new FormData();
      formData.append("mediaContent", thisController.state.fileContent);
      formData.append("folderId", thisController.state.folderId);
      formData.append("type", thisController.state.contentType);
      formData.append(
        "contentId",
        thisController.state.existingContentInfo.contentId
      );
      formData.append("caption", caption);
      formData.append("mediaId", thisController.state.mediaId);
      formData.append("fileContentName", thisController.state.fileContent.name);

      if (caption == "" || !thisController.state.fileContent) {
        thisController.state.errorMsg = "*Please fill all the fields";
        thisController.state.disableDone = false;
        thisController.setState(thisController.state);
      } else if (!thisController.validateContent(fileExtension)) {
        thisController.state.showProgressBar = false;
        thisController.state.disableDone = false;
        thisController.state.errorMsg = "*Invalid content type.";
        thisController.setState(thisController.state);
      } else {
        thisController.state.errorMsg = "";
        if (!thisController.maxOrder) {
          thisController.maxOrder = 0;
        }
        formData.append("order", thisController.maxOrder + 1);

        $.ajax({
          url: "/my-jeeva-api/upload-content",
          method: "POST",
          type: "POST",
          data: formData,
          cache: false,
          contentType: false,
          processData: false,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
          xhr: function () {
            var xhr = new window.XMLHttpRequest();

            //Upload progress
            xhr.upload.addEventListener(
              "progress",
              function (evt) {
                if (evt.lengthComputable) {
                  var percentComplete = Math.floor(
                    (evt.loaded / evt.total) * 100
                  );
                  thisController.state.percentage = percentComplete;

                  thisController.setState(thisController);
                  console.log("Current percentage", percentComplete);
                }
              },
              false
            );

            return xhr;
          },
          success: function (res) {
            if (res.success === true) {
              thisController.fetchContent();
              thisController.state.showAddContentOverLay = false;
              thisController.state.dataStartedProcessing = false;
              thisController.setState(thisController.state);
            } else {
              thisController.state.progressStatus = "error";
              thisController.state.percentage = 100;
              thisController.state.dataStartedProcessing = false;
              thisController.setState(thisController.state);
              thisController.fetchContent();
            }
          },
          error: function (xhr) {
            if (xhr.status == 401) {
              window.location.href = "";
            }
          },
        });
      }
    }
  };
  updateMediaContent = () => {
    this.state.editedId = "-1";
    this.setState(this.state);
    this.state.disableDone = true;
    var updateController = this;
    var caption;
    var imgCaption = document.getElementById("imageCaptionId").value;
    var videoCaption = document.getElementById("videoCaptionId").value;
    var audioCaption = document.getElementById("audioCaptionId").value;
    var captionPattern = new RegExp(
      /^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/
    );
    if (updateController.state.contentType == "IMAGE") {
      caption = imgCaption;
    } else if (updateController.state.contentType == "VIDEO") {
      caption = videoCaption;
    } else if (updateController.state.contentType == "AUDIO") {
      caption = audioCaption;
    }
    var formData = new FormData();
    formData.append("id", updateController.state.idToBeUpdated);
    formData.append("mediaId", updateController.state.mediaId);
    formData.append(
      "contentId",
      updateController.state.existingContentInfo.contentId
    );
    formData.append("type", updateController.state.contentType);
    formData.append("caption", caption);
    if (updateController.state.fileContent) {
      // formData.append("mediaContent", updateController.state.fileContent);
      var newFileContent = document.getElementById("videoContentId").files[0];
      formData.append("mediaContent", newFileContent);
      formData.append(
        "fileContentName",
        updateController.state.fileContent.name
      );
    }

    if (caption == "") {
      updateController.state.errorMsg = "*Please fill all the fields";
      updateController.state.disableDone = false;
    } else if (!captionPattern.test(caption)) {
      updateController.notifyImproperCaption();
      updateController.state.disableDone = false;
    } else {
      if (updateController.state.fileContent) {
        formData.append("mediaContent", updateController.state.fileContent);
        const fileExtension = updateController.state.fileContent.name
          .split(".")
          .pop()
          .toLowerCase();

        if (!updateController.validateContent(fileExtension)) {
          updateController.state.showProgressBar = false;
          updateController.state.disableDone = false;
          updateController.state.errorMsg = "*Invalid content type.";
          return;
        }
      }

      var timer = setInterval(function () {
        clearTimeout(timer);
        $.ajax({
          url: "/my-jeeva-api/update-media-content",

          method: "PATCH",
          data: formData,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
          processData: false,
          contentType: false,
          xhr: function () {
            var xhr = new window.XMLHttpRequest();

            //Upload progress
            xhr.upload.addEventListener(
              "progress",
              function (evt) {
                if (evt.lengthComputable) {
                  var percentComplete = Math.floor(
                    (evt.loaded / evt.total) * 100
                  );
                  updateController.state.percentage = percentComplete;

                  updateController.setState(updateController);
                  console.log("Current percentage", percentComplete);
                }
              },
              false
            );

            return xhr;
          },

          success: function (res) {
            if (res.success === true) {
              updateController.fetchContent();
              updateController.state.showAddContentOverLay = false;
              updateController.setState(updateController.state);
              // window.location.reload();
            } else {
              updateController.notifyFailedResponse(res.result);
            }
          },
          error: function (xhr) {
            if (xhr.status == 401) {
              window.location.href = "";
            }
          },
        });
      });
    }
  };
  handleMouseEnterDoc = (id) => {
    this.state.hoverId = id;
    this.setState(this.state);
  };
  handleMouseLeaveDoc = () => {
    this.state.hoverId = -1;
    this.setState(this.state);
  };
  makeCelleditSubFolder(index) {
    this.markAsBeingEdited(
      this.state.existingContentInfo.subFolderList[index].id
    );
  }
  makeCelleditSection(index) {
    this.markAsBeingEdited(
      this.state.existingContentInfo.documentSections[index].id
    );
  }

  markAsBeingEdited(id) {
    this.state.editedId = id;
    var stateObj = this.state;
    this.setState(stateObj);
  }
  onFolderClick(id) {
    this.state.folderId = id;
    this.setState(this.state);
    this.fetchContent(true);
  }
  onFolderNameClicked(id, depth) {
    var newPath = [];
    var folder;
    for (var i = 0; i < this.state.folderPath.length; i++) {
      folder = this.state.folderPath[i];
      if (folder.depth < depth) {
        newPath.push(folder);
      }
    }
    this.state.folderPath = newPath;
    this.onFolderClick(id);
  }
  deleteFolder = (id) => {
    let deleteRowViewController = this.state.existingContentInfo.subFolderList;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    if (id == "") {
      deleteApiViewController.setState({ deleteRow: true });
      deleteConstructorVariables.setState({ hideDeletePopup: false });
      deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
      deleteRowViewController.splice(id, 1);
      deleteConstructorVariables.fetchContent();
    } else {
      $.ajax({
        url: "/my-jeeva-api/library-module-admin/folder/" + id,

        method: "DELETE",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success === true) {
            deleteApiViewController.state.surveyId = id;
            deleteApiViewController.setState(deleteApiViewController.state);
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
          } else {
            deleteApiViewController.notifyError();
          }
          // Refetch the open folder only once the delete has finished; reloading went back to
          // the root, and a fetch sent alongside the delete could come back with the folder still in it
          deleteConstructorVariables.fetchContent();
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }
  };
  deleteContent = (id) => {
    let deleteRowViewController =
      this.state.existingContentInfo.documentSections;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    if (id == "") {
      deleteApiViewController.setState({ deleteRow: true });
      deleteConstructorVariables.setState({ hideDeletePopup: false });
      deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
      deleteRowViewController.splice(id, 1);
      deleteConstructorVariables.fetchContent();
    } else {
      $.ajax({
        url: "/my-jeeva-api/library-module-admin/section/" + id,

        method: "DELETE",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success === true) {
            deleteApiViewController.state.surveyId = id;
            deleteApiViewController.setState(deleteApiViewController.state);
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
          } else {
            deleteApiViewController.notifyFailedResponse(res.result);
          }
          // Refetch only once the delete has finished, so the deleted content is not shown again
          deleteConstructorVariables.fetchContent();
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }
  };

  notifyError() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Oops! Error occurred.Please try again
      </b>,
      {
        position: "top-center",
      }
    );
  }

  openPublishPopUp = () => {
    confirmAlert({
      title: "Confirm to Publish",
      message: "Are you sure you want to publish this treatment version?",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.publish(),
        },
        {
          label: "No",
        },
      ],
    });
  };

  openUnPublishPopUp = () => {
    confirmAlert({
      title: "Confirm to Unpublish",
      message: "Are you sure to unpublish this?",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.unPublish(),
        },
        {
          label: "No",
        },
      ],
    });
  };

  contentDeletePopUp = (section) => {
    confirmAlert({
      title: "Confirm to Delete",
      message: `Are you sure you want to delete ${section.caption ? section.caption : ""}?`,
      buttons: [
        {
          label: "Yes",
          onClick: () => this.deleteContent(section.id),
        },
        {
          label: "No",
        },
      ],
    });
  };

  notifyDelete() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Folder deleted successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyDeleteContent() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Content deleted successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  sectionTemplate(section) {
    switch (section.type) {
      case "TEXT":
        const htmlContent = section.textContent;
        const modifiedHtmlContent = htmlContent.replace(
          /background-color:\s*[^;]+;/g,
          "background-color: white;"
        );
        return (
          <div className="col-sm-9">
            <div
              style={{
                marginTop: "1vw",
                marginBottom: "1vw",
                marginLeft: "6vw",
                borderRadius: "10px",
                padding: "6px",
                height: "auto",
                backgroundColor: "inherit",
                maxWidth: "50vw",
              }}
              className="textarea"
              dangerouslySetInnerHTML={{ __html: modifiedHtmlContent }}
            ></div>
          </div>
        );
      case "IMAGE":
        var mediaUrl;
        if (section.mediaUrl != null) {
          mediaUrl = section.mediaUrl;
        } else if (section.mediaId != null) {
          mediaUrl = "/my-jeeva-api/media/" + section.mediaId;
        } else {
          mediaUrl = "/assets/images/not-available.jpg";
        }
        return (
          // <div>
          //     <div className='col-sm-2'>
          //         <label style={{ marginLeft: '1vw', marginTop: '1vw' }}>{section.caption}</label>
          //     </div>
          <div className="col-sm-9">
            <div
              className="sectionImage"
              id={"sectionImage" + section.id}
              style={{
                borderRadius: "10px",
                margin: "10px",
                padding: "6px",
                height: "auto",
                textAlign: "center",
              }}
            >
              <img
                src={mediaUrl}
                style={{
                  maxWidth: "50vw",
                  maxHeight: "50vh",
                  textDecoration: "underline",
                  color: "blue",
                  cursor: "pointer",
                }}
              ></img>
            </div>
          </div>
          // </div>
        );
      case "VIDEO":
        var mediaUrl;
        if (section.mediaUrl != null) {
          mediaUrl = section.mediaUrl;
        } else if (section.mediaId != null) {
          mediaUrl = "/my-jeeva-api/stream/" + section.mediaId;
        } else {
          mediaUrl = "/assets/images/not-available.jpg";
        }
        var youtubeVideoPattern = new RegExp(
          /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/
        );

        // Clean YouTube URL by removing playlist params
        var cleanMediaUrl = mediaUrl;
        if (youtubeVideoPattern.test(mediaUrl)) {
          // Extract just the video ID from YouTube URL
          var videoIdMatch = mediaUrl.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/);
          if (videoIdMatch && videoIdMatch[1]) {
            cleanMediaUrl = "https://www.youtube.com/watch?v=" + videoIdMatch[1];
          }
        }

        return (
          <div className="col-sm-9">
            {!youtubeVideoPattern.test(mediaUrl) ? (
              <div
                className="sectionVideo"
                id={"sectionVideo" + section.id}
                style={{
                  borderRadius: "10px",
                  margin: "10px",
                  padding: "6px",
                  height: "auto",
                  textAlign: "center",
                }}
              >
                <video
                  width="650"
                  height="400"
                  controls
                  disablePictureInPicture
                  controlsList="nodownload"
                  style={{
                    maxWidth: "50vw",
                    textDecoration: "underline",
                    color: "blue",
                    cursor: "pointer",
                  }}
                >
                  <source
                    src={mediaUrl}
                    type="video/mp4"
                    style={{
                      maxWidth: "50vw",
                      textDecoration: "underline",
                      color: "blue",
                      cursor: "pointer",
                    }}
                  />
                </video>
              </div>
            ) : (
              <div
                className="sectionVideo"
                id={"sectionVideo" + section.id}
                style={{
                  borderRadius: "10px",
                  margin: "10px",
                  padding: "6px",
                  height: "auto",
                  textAlign: "center",
                }}
              >
                <ReactPlayer
                  url={cleanMediaUrl}
                  className="sectionVideoYoutube"
                  width="650"
                  height="400"
                  controls
                  style={{
                    maxWidth: "50vw",
                    textDecoration: "underline",
                    color: "blue",
                    cursor: "pointer",
                  }}
                />
              </div>
            )}
          </div>

          // </div>
        );
      case "AUDIO":
        var mediaUrl;
        if (section.mediaUrl != null) {
          mediaUrl = section.mediaUrl;
        } else if (section.mediaId != null) {
          mediaUrl = "/my-jeeva-api/stream/" + section.mediaId;
        } else {
          mediaUrl = "/assets/images/not-available.jpg";
        }
        var onlineMusicAppPattern = new RegExp(
          /^(?:https?:\/\/)?(?:www\.)?(?:soundcloud\.com|snd\.sc)\/([a-zA-Z0-9-_]+)\/(?:(?:sets\/)?([a-zA-Z0-9-_]+)|(?:[^\/?]+))(?:\?.*)?$/
        );

        return (
          <div className="col-sm-9">
            {!onlineMusicAppPattern.test(mediaUrl) ? (
              <div
                className="sectionAudio"
                id={"sectionAudio" + section.id}
                style={{
                  borderRadius: "10px",
                  margin: "10px",
                  padding: "6px",
                  height: "auto",
                  textAlign: "center",
                }}
              >
                <audio
                  controlsList="nodownload"
                  controls
                  style={{ width: "50vw" }}
                >
                  <source
                    src={mediaUrl}
                    type="audio/mpeg"
                    style={{
                      maxWidth: "50vw",
                      textDecoration: "underline",
                      color: "blue",
                      cursor: "pointer",
                    }}
                  />
                </audio>
              </div>
            ) : (
              <div
                className="sectionAudio"
                id={"sectionAudio" + section.id}
                style={{
                  borderRadius: "10px",
                  margin: "10px",
                  padding: "6px",
                  height: "auto",
                  textAlign: "center",
                }}
              >
                <ReactPlayer
                  className="sectionOnlineAudio"
                  url={mediaUrl}
                  controls
                  controlsList="nodownload"
                  style={{ width: "50vw" }}
                />
              </div>
            )}
          </div>
        );
    }
  }
  changeContent = () => {
    this.state.fileContentUpload = false;
    this.setState(this.state);
  };
  onChangeRadioButton = (event) => {
    this.state.errorMsg = "";
    if (event.target.value == "uploadURLContent") {
      this.state.selectedOption = "uploadURLContent";
      this.state.uploadURLContent = true;
    } else {
      this.state.selectedOption = "uploadFileContent";
      this.state.uploadURLContent = false;
    }

    this.setState(this.state);
  };

  // Unpublish with callback - used when user needs to unpublish before editing
  unpublishContent = (callback) => {
    var unPublishController = this;
    $.ajax({
      url: "/my-jeeva-api/library-module-admin/unpublish/" + this.state.existingContentInfo.contentId,
      method: "PATCH",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success == true) {
          unPublishController.fetchContent();
          // Execute callback after unpublishing (e.g., open editor)
          if (callback) {
            setTimeout(() => callback(), 500);
          }
        }
      },
    });
  };

  unPublish = () => {
    var unPublishController = this;
    $.ajax({
      url: "/my-jeeva-api/library-module-admin/unpublish/" + this.state.existingContentInfo.contentId,

      method: "PATCH",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success == true) {
          //unPublishController.setState({ hideDeleteUnpublishPopup: false });
          unPublishController.fetchContent();
        }
      },
    });
  };

  publish = () => {
    var publishController = this;
    $.ajax({
      url: "/my-jeeva-api/library-module-admin/publish/" + this.state.existingContentInfo.contentId,

      method: "PATCH",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success == true) {
          console.log(
            "The state of published :" + publishController.state.published
          );
          publishController.notifySuccess(publishController.newVersionInfo);

          // Fetch content after publish to update published flag
          setTimeout(() => {
            publishController.fetchContent();
          }, 500);

          //window.location.reload();
        }
      },
    });
  };

  notifySuccess(msg) {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;{msg}
      </b>,
      {
        position: "top-center",
      }
    );
  }

  validateContent(fileExtension) {
    let validExtensions = [];

    if (this.state.contentType === "IMAGE") {
      validExtensions = ["jpg", "jpeg", "png", "gif"];
    } else if (this.state.contentType === "VIDEO") {
      validExtensions = ["mp4", "mov", "avi", "mkv"];
    } else if (this.state.contentType === "AUDIO") {
      validExtensions = ["mp3", "wav", "aac", "mpeg"];
    }

    if (validExtensions.indexOf(fileExtension) === -1) {
      return false;
    }

    return true;
  }

  uploadMediaContent = () => {
    this.state.showProgressBar = true;
    switch (this.state.contentType) {
      case "TEXT":
        if (this.state.updatingContent) {
          this.updateTextContent();
          break;
        } else {
          this.saveContentFromUrl();
          break;
        }
      case "IMAGE":
        if (this.state.updatingContent) {
          if (this.state.imageUrlUpload) {
            this.saveContentFromUrl(event);
          } else {
            this.updateMediaContent();
          }
        } else {
          if (this.state.uploadURLContent) {
            this.saveContentFromUrl(event);
          } else {
            this.saveContentFromFileUpload(event);
          }
        }
        break;
      case "VIDEO":
        if (this.state.updatingContent) {
          // this.updateMediaContent();
          if (this.state.videoUrlUpload) {
            this.saveContentFromUrl(event);
          } else {
            // this.saveContentFromUrl(event);
            this.updateMediaContent();
          }
        } else {
          if (this.state.videoUrlUpload) {
            this.saveContentFromUrl(event);
          } else {
            this.saveContentFromFileUpload(event);
          }
        }
        break;

      case "AUDIO":
        if (this.state.updatingContent) {
          // this.updateMediaContent();
          if (this.state.audioUrlUpload) {
            this.saveContentFromUrl(event);
          } else {
            // this.saveContentFromUrl(event);
            this.updateMediaContent();
          }
        } else {
          if (this.state.audioUrlUpload) {
            this.saveContentFromUrl(event);
          } else {
            this.saveContentFromFileUpload(event);
          }
        }
        break;
      /*
      if (this.state.updatingContent) {
        this.updateMediaContent();
        break;
      } else if (this.state.fileContentUpload) {
        this.saveContentFromFileUpload(event);
        break;
      } else {
        this.saveContentFromUrl(event);
        break;
      }
      */
    }
  };
  imageUrl = () => {
    this.state.imageUrlUpload = true;
    this.setState(this.state);
  };
  videoUrl = () => {
    this.state.videoUrlUpload = true;
    this.setState(this.state);
  };
  audioUrl = () => {
    this.state.audioUrlUpload = true;
    this.setState(this.state);
  };
  folderDeletePopUp = (folder) => {
    confirmAlert({
      title: "Confirm to Delete",
      message: `Are you sure you want to delete ${folder.label}?`,
      buttons: [
        {
          label: "Yes",
          onClick: () => this.deleteFolder(folder.id),
        },
        {
          label: "No",
        },
      ],
    });
  };
  changingSectionOrders = (dragId, dropId) => {
    var thisController = this;
    console.log("The drag id is :" + dragId);
    console.log("The drop id is :" + dropId);

    $.ajax({
      url: "/my-jeeva-api/library-module-admin/section-order/" + dragId + "/" + dropId,
      method: "PATCH",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success == true) {
          console.log(
            "The orders has been swapped"
          );
          thisController.fetchContent();

          //window.location.reload();
        }
      },
    });

  }

  changingFolderOrders = (dragId, dropId) => {
    var thisController = this;
    console.log("The folder drag id is :" + dragId);
    console.log("The folder drop id is :" + dropId);

    $.ajax({
      url: "/my-jeeva-api/library-module-admin/folder-order/" + dragId + "/" + dropId,
      method: "PATCH",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success == true) {
          console.log(
            "The orders has been swapped"
          );
          thisController.fetchContent();

          //window.location.reload();
        }
      },
    });

  }
  dragStart = (e, index, id) => {
    e.dataTransfer.setData("index", index);
    e.dataTransfer.setData("id", id);
  };

  dragOver = (e) => {
    e.preventDefault();
  };

  drop = (e, dropIndex, content, dropId) => {
    e.preventDefault();
    const dragIndex = e.dataTransfer.getData("index");
    const dragId = e.dataTransfer.getData("id");
    // Retrieve the sections array
    var sections = [];
    if (content == "document") {
      sections = [...this.state.existingContentInfo.documentSections];

      // Remove the dragged section from its current index
      const draggedSection = sections.splice(dragIndex, 1)[0];

      // Insert the dragged section at the drop index
      sections.splice(dropIndex, 0, draggedSection);

      // Update the state with the new order of sections
      // this.setState({
      //   existingContentInfo: {
      //     ...this.state.existingContentInfo,
      //     documentSections: sections,
      //   },
      // });
      this.changingSectionOrders(dragId, dropId);
    } else if (content == "subFolder") {
      sections = [...this.state.existingContentInfo.subFolderList];

      // Remove the dragged section from its current index
      const draggedSection = sections.splice(dragIndex, 1)[0];

      // Insert the dragged section at the drop index
      sections.splice(dropIndex, 0, draggedSection);

      // Update the state with the new order of sections
      // this.setState({
      //   existingContentInfo: {
      //     ...this.state.existingContentInfo,
      //     subFolderList: sections,
      //   },
      // });
      this.changingFolderOrders(dragId, dropId);
    }

  };


  render() {
    const { editorState } = this.state;
    return (
      <div id="contentLibForTreatmentTab">
        {this.state.translationFor && (
          <TranslationPanel
            entityType={this.state.translationFor.entityType}
            entityId={this.state.translationFor.entityId}
            title={this.state.translationFor.title}
            fields={this.state.translationFor.fields}
            sourceFields={this.state.translationFor.sourceFields}
            procedureId={this.props.location.state && this.props.location.state.treatmentId}
            onClose={() => this.setState({ translationFor: null })}
          />
        )}
        {this.state.moving && (
          <MoveToFolderPanel
            libraryModuleId={this.state.existingContentInfo.contentId}
            kind={this.state.moving.kind}
            item={this.state.moving.item}
            onMoved={(target) => {
              const what = this.state.moving.kind === "folder" ? "Folder" : "Section";
              this.setState({ moving: null });
              toast.dismiss();
              toast(
                <div>
                  <b style={{ display: "flex", alignItems: "center" }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2e9e4f"
                      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                      style={{ marginRight: 10, flexShrink: 0 }}>
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="8 12.5 11 15.5 16.5 9.5" />
                    </svg>
                    {what} moved successfully!
                  </b>
                  {target && (
                    <div style={{ marginTop: 8, fontSize: 14, color: "#666" }}>
                      Destination: {target.path}
                    </div>
                  )}
                </div>,
                {
                  position: "top-center",
                }
              );
              this.fetchContent();
            }}
            onClose={() => this.setState({ moving: null })}
          />
        )}
        {/* <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={this.state.showLoader}
                    height={300}
                    width={50}
                    style={{ textAlign: 'center' }} /> */}

        <div style={{ display: !this.state.showLoader ? "block" : "none" }}>
          <link rel="stylesheet" href="assets/css/modal-style.css" />

          <link rel="stylesheet" href="assets/css/toggleButton.css" />
          {/* for toaster */}
          <link rel="stylesheet" href="./assets/css/ReactToastify.css" />

          {/* for dialog component */}
          <link href="./assets/css/ej2-base.css" rel="stylesheet" />
          <link href="./assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="./assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="./assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="./assets/css/screenResolution.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="./assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />

          {/* <ToastContainer className="Toast-at-center" /> */}

          <div className="content-header">
            <div className="row">
              <div className="col-sm-6">
                <h6
                  className="nav-item"
                  style={{
                    color: "#282a65",
                    marginTop: "1vh",
                    marginLeft: "1vw",
                  }}
                >
                  Manage Content of {this.state.existingContentInfo.folderTitle}
                </h6>
              </div>
              <div
                className="col-sm-6"
                align="right"
                style={{ paddingRight: "14px" }}
              >
                <div style={{ display: "flex", alignItems: "center", justifyContent: "end" }}>
                  <h6
                    className="nav-item"
                    style={{
                      color: "#282a65",
                      marginTop: "1vh",
                    }}
                  >
                    Publish :
                  </h6>
                  &nbsp;&nbsp;
                  <label className="switch">
                    <input
                      type="checkbox"
                      id="isPublished"
                      checked={this.state.published}
                      disabled={this.userDetails["userRole"] === "PROVIDER"}
                      onClick={this.userDetails["userRole"] === "PROVIDER" ||
                        (this.userDetails["userRole"] === "PHYSICIAN" &&
                        JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy")) ? null :
                        () =>
                          this.state.published
                            ? this.openUnPublishPopUp()
                            : this.openPublishPopUp()
                      }
                    />
                    <span className="slider round"></span>
                  </label>
                  <button
                    className="btn action-button"
                    style={{
                      display: this.state.userRole == "PHYSICIAN" ? "block" : "none",
                      marginLeft: "1.5rem"
                    }}
                    onClick={this.handleOpenBrowseModal}
                  >
                    Content Library
                  </button>
                </div>
              </div>
            </div>

            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="card-body p-0 mb-25">
                    <div className="tab-content col-12 p-0">
                      <div className="tab-pane active show" id="tab_1">
                        <div className="card card-primary mt-3">
                          <div className="card-body raise-form">
                            <div className="row">
                              <div
                                className="col-sm-12"
                                align="center"
                                style={{
                                  display: this.state.showNoData
                                    ? "block"
                                    : "none",
                                  marginTop: "10%",
                                }}
                              >
                                <div
                                  style={{
                                    width: "40%",
                                    fontSize: "22px",
                                    color: "#282a65",
                                    marginTop: "-50px",
                                  }}
                                >
                                  <h3
                                    className="m-0 page-title"
                                    style={{ textAlign: "center" }}
                                  >
                                    No content added yet!
                                  </h3>
                                  <br />
                                  <label>
                                    It seems there is no content added.
                                  </label>
                                  <br />
                                  <label>
                                    Please use below button to add content.
                                  </label>
                                </div>
                              </div>
                              <div className="row" style={{ display: "block" }}>
                                <h2
                                  className="page-title"
                                  style={{
                                    marginLeft: "1em",
                                    marginBottom: "1em",
                                    paddingTop: "0px",
                                  }}
                                >
                                  <img
                                    src="assets/images/folder.png"
                                    style={{
                                      paddingRight: "0px",
                                      height: "30px",
                                      width: "30px",
                                    }}
                                    content=""
                                  />
                                  {this.state.folderPath.map((el, i) => (
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.onFolderNameClicked(
                                          el.id,
                                          el.depth
                                        )
                                      }
                                    >
                                      {" / " + el.label}
                                    </a>
                                  ))}
                                </h2>
                              </div>
                              <div style={{ width: "100%" }}>
                                {this.state.existingContentInfo && this.state.existingContentInfo.documentSections && this.state.existingContentInfo.documentSections.map(
                                  (section, i) => (
                                    <div key={i}
                                      draggable="true"
                                      className="libContent"
                                      // onDragStart={(e) => this.dragStart(e, i, section.id)}
                                      // onDragOver={(e) => this.dragOver(e)}
                                      // onDrop={(e) => this.drop(e, i, "document", section.id)}
                                      onDragStart={
                                        this.userDetails["userRole"] === "PHYSICIAN" &&
                                          JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy")
                                          ? null
                                          : (e) => this.dragStart(e, i, section.id)
                                      }
                                      // Conditionally apply onDragOver only if the condition is met
                                      onDragOver={
                                        this.userDetails["userRole"] === "PHYSICIAN" &&
                                          JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy")
                                          ? null
                                          : (e) => this.dragOver(e)
                                      }
                                      onDrop={this.userDetails["userRole"] === "PHYSICIAN" &&
                                        JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy")
                                        ? null
                                        : (e) => this.drop(e, i, "document", section.id)}
                                    >
                                      <div
                                        className="fontpreviewBox"
                                        style={{
                                          borderRadius: "1vw",
                                          marginTop: "1vw",
                                          boxShadow: "0 0 5px 0 #c2c4d2",
                                          cursor: "grab"
                                        }}

                                      >
                                        <div
                                          className={
                                            section.caption != null ? "row" : ""
                                          }
                                        >
                                          <label
                                            style={{
                                              display:
                                                section.caption != null
                                                  ? "block"
                                                  : "none",
                                              color: "rgb(40, 42, 101)",
                                              marginTop: "1vw",
                                              marginLeft: "2vw",
                                              fontWeight: "430",
                                              fontSize: "18px",
                                            }}
                                          >
                                            {section.caption}
                                          </label>
                                        </div>
                                        <div className="row">
                                          {this.sectionTemplate(section)}
                                          <div
                                            className="col-sm-3"
                                            align="right"
                                            style={{ paddingRight: "3vh" }}
                                          >
                                            <button
                                              style={{
                                                backgroundColor: "#ffffff",
                                                border: "none",
                                                marginTop: "0.5vw",
                                                marginLeft: "-6px",
                                              }}
                                            >
                                              <img
                                                className="img-responsive"
                                                title={
                                                  section.id == "" ||
                                                    section.id ==
                                                    this.state.editedId
                                                    ? "Save"
                                                    : "Edit"
                                                }
                                                style={{
                                                  marginTop: "6px",
                                                  backgroundColor: (this.userDetails["userRole"] === "PROVIDER" ||
                                                    (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy"))) ? "#282a6596" : "#282a65",
                                                  borderRadius: "5px",
                                                  padding: "1px",
                                                }}
                                                src={
                                                  section.id == ""
                                                    ? this.saveImageSrc
                                                    : this.state.showAddContentOverLay &&
                                                      section.id == this.state.idToBeUpdated
                                                      ? this.saveImageSrc
                                                      : this.editImageSrc
                                                }

                                                // onClick={() =>
                                                //   this.startUpdatingSection(
                                                //     section,
                                                //     i
                                                //   )
                                                // }

                                                onClick={
                                                  this.userDetails["userRole"] === "PROVIDER" ||
                                                  (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy"))
                                                    ? null
                                                    : () =>
                                                      this.startUpdatingSection(
                                                        section,
                                                        i
                                                      )
                                                }
                                              />
                                            </button>
                                            {section.id && section.id !== "" && (
                                              <button
                                                title="Move to another folder"
                                                style={{
                                                  backgroundColor: "#ffffff",
                                                  border: "none",
                                                  marginTop: "0.5vw",
                                                  marginLeft: "6px",
                                                  cursor: "pointer",
                                                }}
                                                onClick={
                                                  this.userDetails["userRole"] === "PROVIDER" ||
                                                  (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy"))
                                                    ? null
                                                    : () => this.setState({ moving: { kind: "section", item: section } })
                                                }
                                              >
                                                <img
                                                  className="img-responsive"
                                                  src="./assets/images/drive_file_move_white_24dp.svg"
                                                  alt="move"
                                                  style={{
                                                    marginTop: "6px",
                                                    backgroundColor: (this.userDetails["userRole"] === "PROVIDER" ||
                                                      (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                      JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy"))) ? "#282a6596" : "#282a65",
                                                    borderRadius: "5px",
                                                    padding: "1px",
                                                  }}
                                                />
                                              </button>
                                            )}
                                            {section.id && section.id !== "" && (
                                              <button
                                                title="Edit translations"
                                                style={{
                                                  backgroundColor: "#ffffff",
                                                  border: "none",
                                                  marginTop: "0.5vw",
                                                  marginLeft: "-6px",
                                                  cursor: "pointer",
                                                  fontSize: "16px",
                                                }}
                                                onClick={() =>
                                                  this.setState({
                                                    translationFor: {
                                                      entityType: "section",
                                                      entityId: section.id,
                                                      procedureId: this.props.location.state.treatmentId,
                                                      title: section.caption || "Section",
                                                      fields:
                                                        (section.type || section.sectionType) === "TEXT"
                                                          ? [{ name: "textContent", label: "Text content", rich: true }]
                                                          : [{ name: "caption", label: "Caption", rows: 2 }],
                                                      sourceFields: {
                                                        textContent: section.textContent,
                                                        caption: section.caption,
                                                      },
                                                    },
                                                  })
                                                }
                                              >
                                                <img className="img-responsive" src="./assets/images/translate_white_24dp.svg" alt="translate" style={{ marginTop: "6px", backgroundColor: "#282a65", borderRadius: "5px", padding: "1px" }} />
                                              </button>
                                            )}
                                            <button
                                              style={{
                                                backgroundColor: "#ffffff",
                                                border: "none",
                                                marginTop: "0.5vw",
                                                marginLeft: "-6px",
                                              }}
                                              title="Delete"
                                            >
                                              <img
                                                className="img-responsive"
                                                src={
                                                  "./assets/images/baseline_delete_white_24dp.png"
                                                }
                                                style={{
                                                  marginTop: "6px",
                                                  backgroundColor: (this.userDetails["userRole"] === "PROVIDER" ||
                                                    (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy"))) ? "#282a6596" : "#282a65",
                                                  borderRadius: "5px",
                                                  padding: "1px",
                                                }}
                                                // onClick={() =>
                                                //   section.id === ""
                                                //     ? this.fetchContent()
                                                //     : this.contentDeletePopUp(
                                                //       section
                                                //     )
                                                // }

                                                onClick={
                                                  this.userDetails["userRole"] === "PROVIDER" ||
                                                  (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy"))
                                                    ? null
                                                    : () =>
                                                      section.id === ""
                                                        ? this.fetchContent()
                                                        : this.contentDeletePopUp(
                                                          section
                                                        )
                                                }

                                              // this.setState({
                                              //     type: 'content',
                                              //     hideDeletePopup: true, deletePropIndex: i, propsId: section.id
                                              // })}
                                              />
                                            </button>
                                            <button
                                              style={{
                                                backgroundColor: "#ffffff",
                                                border: "none",
                                                marginTop: "0.5vw",
                                                marginLeft: "-6px",
                                              }}
                                              draggable="true"
                                              // Initiate drag operation on drag start event
                                              // onDragStart={(e) => this.dragStart(e, i, section.id)}
                                              // onDragOver={(e) => this.dragOver(e)}
                                              // onDrop={(e) => this.drop(e, i, "document", section.id)}
                                              onDragStart={
                                                this.userDetails["userRole"] === "PROVIDER" ||
                                                (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                  JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy"))
                                                  ? null
                                                  : (e) => this.dragStart(e, i, section.id)
                                              }
                                              // Conditionally apply onDragOver only if the condition is met
                                              onDragOver={
                                                this.userDetails["userRole"] === "PROVIDER" ||
                                                (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                  JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy"))
                                                  ? null
                                                  : (e) => this.dragOver(e)
                                              }
                                            >
                                              <img
                                                className="img-responsive"
                                                title="Drag"
                                                style={{
                                                  marginTop: "6px",
                                                  backgroundColor: (this.userDetails["userRole"] === "PROVIDER" ||
                                                    (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy"))) ? "#282a6596" : "#282a65",
                                                  borderRadius: "5px",
                                                  padding: "2px",
                                                  height: "3vh"
                                                }}
                                                src="./assets/images/Drag Reorder.svg"
                                              />
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )
                                )}

                                {this.state.existingContentInfo && this.state.existingContentInfo.subFolderList && this.state.existingContentInfo.subFolderList.map(
                                  (el, i) => (
                                    <div key={i} draggable="true"
                                      // onDragStart={(e) => this.dragStart(e, i, el.id)}
                                      // onDragOver={(e) => this.dragOver(e)}
                                      // onDrop={(e) => this.drop(e, i, "subFolder", el.id)}
                                      onDragStart={
                                        this.userDetails["userRole"] === "PHYSICIAN" &&
                                          JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy")
                                          ? null
                                          : (e) => this.dragStart(e, i, el.id)
                                      }
                                      // Conditionally apply onDragOver only if the condition is met
                                      onDragOver={
                                        this.userDetails["userRole"] === "PHYSICIAN" &&
                                          JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy")
                                          ? null
                                          : (e) => this.dragOver(e)
                                      }
                                      onDrop={this.userDetails["userRole"] === "PHYSICIAN" &&
                                        JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy")
                                        ? null
                                        : (e) => this.drop(e, i, "subFolder", el.id)}
                                    >
                                      <div>
                                        <div style={{
                                          cursor: "grab"
                                        }} >
                                          <div
                                            className="row"
                                            style={{
                                              padding: "1vw",
                                              borderRadius: "1vw",
                                              boxShadow: "0 0 5px 0 #c2c4d2",
                                              marginLeft: "0.1vw",
                                              marginTop: "1vw",
                                              marginRight: "-0.2vw",
                                            }}
                                          >
                                            <div
                                              className="col-sm-1"
                                              onClick={() =>
                                                this.onFolderClick(
                                                  this.state.existingContentInfo
                                                    .subFolderList[i].id
                                                )
                                              }
                                              subFolderList
                                            >
                                              <div className="previewText image-container">
                                                <img
                                                  id="qr_code"
                                                  src={this.state.existingContentInfo.subFolderList[i].icon ?
                                                    "data:image/png;base64," +
                                                    this.state
                                                      .existingContentInfo
                                                      .subFolderList[i].icon : ""
                                                  }
                                                  style={{
                                                    width: "9vw",
                                                    marginLeft: "-1vw",
                                                    height: "8vw",
                                                    borderRadius: "1vw",
                                                    cursor: "pointer",
                                                  }}
                                                />
                                              </div>
                                            </div>

                                            <div
                                              className="col-sm-8"
                                              style={{ paddingLeft: "3vw" }}
                                            >
                                              <h3
                                                className="m-0 page-title"
                                                style={{
                                                  paddingBottom: "1vw",
                                                  paddingTop: "1vw",
                                                  border:
                                                    this.state
                                                      .existingContentInfo
                                                      .subFolderList[i].id ==
                                                      "" ||
                                                      this.state
                                                        .existingContentInfo
                                                        .subFolderList[i].id ==
                                                      this.state.editedId
                                                      ? "1px solid #D2D4DC"
                                                      : "none",
                                                  borderRadius:
                                                    this.state
                                                      .existingContentInfo
                                                      .subFolderList[i].id ==
                                                      "" ||
                                                      this.state
                                                        .existingContentInfo
                                                        .subFolderList[i].id ==
                                                      this.state.editedId
                                                      ? "6px"
                                                      : "none",
                                                }}
                                              >
                                                {
                                                  this.state.existingContentInfo
                                                    .subFolderList[i].label
                                                }
                                              </h3>

                                              <div
                                                className="textarea"
                                                style={{
                                                  textAlign: "left",
                                                  height: "2.7em",
                                                  resize: "none",
                                                  paddingTop: "6px",
                                                  marginTop: "1vw",

                                                  border:
                                                    this.state
                                                      .existingContentInfo
                                                      .subFolderList[i].id ==
                                                      "" ||
                                                      this.state
                                                        .existingContentInfo
                                                        .subFolderList[i].id ==
                                                      this.state.editedId
                                                      ? "1px solid #D2D4DC"
                                                      : "none",
                                                  borderRadius:
                                                    this.state
                                                      .existingContentInfo
                                                      .subFolderList[i].id ==
                                                      "" ||
                                                      this.state
                                                        .existingContentInfo
                                                        .subFolderList[i].id ==
                                                      this.state.editedId
                                                      ? "6px"
                                                      : "none",
                                                }}
                                                id={"descriptionId" + [i]}
                                                contentEditable={
                                                  !(this.state
                                                    .existingContentInfo
                                                    .subFolderList[i].id == ""
                                                    ? false
                                                    : this.state
                                                      .existingContentInfo
                                                      .subFolderList[i].id !=
                                                    this.state.editedId)
                                                    ? "plaintext-only"
                                                    : false
                                                }
                                              >
                                                {
                                                  this.state.existingContentInfo
                                                    .subFolderList[i]
                                                    .description
                                                }
                                              </div>
                                            </div>
                                            <div
                                              className="col-sm-3"
                                              align="right"
                                            >
                                              <button
                                                style={{
                                                  backgroundColor: "#ffffff",
                                                  border: "none",
                                                  marginTop: "0.5vw",
                                                  marginLeft: "-6px",
                                                }}
                                              >
                                                <img
                                                  className="img-responsive"
                                                  title={
                                                    this.state
                                                      .existingContentInfo
                                                      .subFolderList[i].id ==
                                                      "" ||
                                                      this.state
                                                        .existingContentInfo
                                                        .subFolderList[i].id ==
                                                      this.state.editedId
                                                      ? "Save"
                                                      : "Edit"
                                                  }
                                                  disabled={this.userDetails["userRole"] === "PROVIDER" ||
                                                    (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy"))}
                                                  style={{
                                                    marginTop: "6px",
                                                    backgroundColor: (this.userDetails["userRole"] === "PROVIDER" ||
                                                      (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                      JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy"))) ? "#282a6596" : "#282a65",
                                                    borderRadius: "5px",
                                                    padding: "1px",
                                                  }}
                                                  src={
                                                    this.state
                                                      .existingContentInfo
                                                      .subFolderList[i].id == ""
                                                      ? this.saveImageSrc
                                                      : this.state.showAddFolderOverLay &&
                                                        this.state.updatingFolder &&
                                                        el.id == this.state.idToBeUpdated
                                                        ? this.saveImageSrc
                                                        : this.editImageSrc
                                                  }
                                                  // onClick={(e) => {
                                                  //   this.startUpdatingFolder(
                                                  //     el,
                                                  //     i
                                                  //   );
                                                  // }}
                                                  onClick={
                                                    this.userDetails["userRole"] === "PROVIDER" ||
                                                    (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                      JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy"))
                                                      ? null
                                                      : () =>
                                                        this.startUpdatingFolder(
                                                          el,
                                                          i
                                                        )
                                                  }
                                                />
                                              </button>
                                              {el.id && el.id !== "" && (
                                                <button
                                                  title="Move to another folder"
                                                  style={{
                                                    backgroundColor: "#ffffff",
                                                    border: "none",
                                                    marginTop: "0.5vw",
                                                    marginLeft: "6px",
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={
                                                    this.userDetails["userRole"] === "PROVIDER" ||
                                                    (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                      JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy"))
                                                      ? null
                                                      : () => this.setState({ moving: { kind: "folder", item: el } })
                                                  }
                                                >
                                                  <img
                                                    className="img-responsive"
                                                    src="./assets/images/drive_file_move_white_24dp.svg"
                                                    alt="move"
                                                    style={{
                                                      marginTop: "6px",
                                                      backgroundColor: (this.userDetails["userRole"] === "PROVIDER" ||
                                                        (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                        JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy"))) ? "#282a6596" : "#282a65",
                                                      borderRadius: "5px",
                                                      padding: "1px",
                                                    }}
                                                  />
                                                </button>
                                              )}
                                              {el.id && el.id !== "" && (
                                                <button
                                                  title="Edit translations"
                                                  style={{
                                                    backgroundColor: "#ffffff",
                                                    border: "none",
                                                    marginTop: "0.5vw",
                                                    marginLeft: "-6px",
                                                    cursor: "pointer",
                                                    fontSize: "16px",
                                                  }}
                                                  onClick={() =>
                                                    this.setState({
                                                      translationFor: {
                                                        entityType: "folder",
                                                        entityId: el.id,
                                                        procedureId: this.props.location.state.treatmentId,
                                                        title: el.label || "Folder",
                                                        fields: [
                                                          { name: "label", label: "Label", rows: 1 },
                                                          { name: "description", label: "Description", rich: true },
                                                        ],
                                                        sourceFields: {
                                                          label: el.label,
                                                          description: el.description,
                                                        },
                                                      },
                                                    })
                                                  }
                                                >
                                                  <img className="img-responsive" src="./assets/images/translate_white_24dp.svg" alt="translate" style={{ marginTop: "6px", backgroundColor: "#282a65", borderRadius: "5px", padding: "1px" }} />
                                                </button>
                                              )}
                                              <button
                                                style={{
                                                  backgroundColor: "#ffffff",
                                                  border: "none",
                                                  marginTop: "0.5vw",
                                                  marginLeft: "-6px",
                                                }}
                                                title="Delete"
                                              >
                                                <img
                                                  className="img-responsive"
                                                  src={
                                                    "./assets/images/baseline_delete_white_24dp.png"
                                                  }
                                                  disabled={this.userDetails["userRole"] === "PROVIDER" ||
                                                    (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy"))}
                                                  style={{
                                                    marginTop: "6px",
                                                    backgroundColor: (this.userDetails["userRole"] === "PROVIDER" ||
                                                      (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                      JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy"))) ? "#282a6596" : "#282a65",
                                                    borderRadius: "5px",
                                                    padding: "1px",
                                                  }}

                                                  // onClick={() =>
                                                  //   this.state
                                                  //     .existingContentInfo
                                                  //     .subFolderList[i].id ===
                                                  //     ""
                                                  //     ? this.fetchContent()
                                                  //     : this.folderDeletePopUp(
                                                  //       this.state
                                                  //         .existingContentInfo
                                                  //         .subFolderList[i]
                                                  //     )
                                                  // }
                                                  onClick={
                                                    this.userDetails["userRole"] === "PROVIDER" ||
                                                    (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                      JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy"))
                                                      ? null
                                                      : () =>
                                                        this.state.existingContentInfo.subFolderList[i].id === ""
                                                          ? this.fetchContent()
                                                          : this.folderDeletePopUp(
                                                            this.state.existingContentInfo.subFolderList[i]
                                                          )
                                                  }
                                                />
                                              </button>
                                              <button
                                                style={{
                                                  backgroundColor: "#ffffff",
                                                  border: "none",
                                                  marginTop: "0.5vw",
                                                  marginLeft: "-6px",
                                                }}
                                                draggable="true"
                                                onDragStart={
                                                  this.userDetails["userRole"] === "PROVIDER" ||
                                                  (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy"))
                                                    ? null
                                                    : (e) => this.dragStart(e, i, el.id)
                                                }
                                                // Conditionally apply onDragOver only if the condition is met
                                                onDragOver={
                                                  this.userDetails["userRole"] === "PROVIDER" ||
                                                  (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy"))
                                                    ? null
                                                    : (e) => this.dragOver(e)
                                                }
                                              >
                                                <img
                                                  className="img-responsive"
                                                  title="Drag"
                                                  disabled={this.userDetails["userRole"] === "PROVIDER" ||
                                                    (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy"))}
                                                  style={{
                                                    marginTop: "6px",
                                                    backgroundColor: (this.userDetails["userRole"] === "PROVIDER" ||
                                                      (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                      JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy"))) ? "#282a6596" : "#282a65",
                                                    borderRadius: "5px",
                                                    padding: "2px",
                                                    height: "3vh"
                                                  }}
                                                  src="./assets/images/Drag Reorder.svg"
                                                />
                                              </button>
                                            </div>
                                            <br />
                                            <br />
                                          </div>
                                          <br />
                                        </div>
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-4"></div>
                              <div className="col-sm-4"></div>
                              <div
                                className="col-sm-4"
                                Align="right"
                                style={{ paddingRight: "2vw" }}
                              >
                                <button
                                  className="btn action-button"
                                  style={{
                                    marginRight: "0.5vw",
                                    width: "7.5vw",
                                  }}
                                  onClick={this.userDetails["userRole"] === "PROVIDER" ||
                                    (this.userDetails["userRole"] === "PHYSICIAN" &&
                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy")) ? null
                                    : () => this.startAddingFolder()}
                                  disabled={this.userDetails["userRole"] === "PROVIDER" ||
                                    (this.userDetails["userRole"] === "PHYSICIAN" &&
                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy"))}
                                >
                                  Add Folder
                                </button>
                                <button
                                  className="btn action-button"
                                  onClick={this.userDetails["userRole"] === "PROVIDER" ||
                                    (this.userDetails["userRole"] === "PHYSICIAN" &&
                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy")) ? null :
                                    this.startAddingContent}
                                  disabled={this.userDetails["userRole"] === "PROVIDER" ||
                                    (this.userDetails["userRole"] === "PHYSICIAN" &&
                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy"))}

                                >
                                  Add Content
                                </button>
                                <button
                                  className="btn action-button"
                                  onClick={this.onPreviewButtonClick}
                                >
                                  Preview
                                </button>
                              </div>
                            </div>
                            {/* ------------- ADD FOLDER -----------               */}
                            <div
                              className="modal"
                              style={{
                                display: this.state.showAddFolderOverLay
                                  ? "block"
                                  : "none",
                              }}
                            >
                              <div
                                className="modal-dialog"
                                id="center-aligned-account-modal"
                              >
                                <div
                                  className="modal-content"
                                  style={{
                                    position: "absolute",
                                    transform: "translate(7%, -7%)",
                                    height: "auto",
                                    width: "48vw",
                                    marginTop: "15vh",
                                  }}
                                  Align="center"
                                >
                                  {!this.state.isSafari &&

                                    <div className="modal-header noBorder">

                                      <button
                                        type="button"
                                        className="close"
                                        data-dismiss="modal"
                                        id="close_id"
                                        onClick={() =>
                                          this.closeAddFolderoverLay()
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"

                                        >
                                          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                          <path d="M0 0h24v24H0z" fill="none" />
                                        </svg>
                                      </button>
                                    </div>
                                  }

                                  {this.state.isSafari &&
                                    <button type="button"
                                      className="close"
                                      style={{ color: "#282a65", marginLeft: "40vw" }}
                                      onClick={() =>
                                        this.closeAddFolderoverLay()
                                      }
                                    >
                                      <span>&times;</span>
                                    </button>
                                  }

                                  <div className="modal-body">
                                    <form>
                                      <span
                                        className="errorMsg"
                                        style={{
                                          color: "red",
                                          fontSize: "18px",
                                          fontWeight: "400",
                                        }}
                                      >
                                        {this.state.errorMsg}
                                      </span>
                                      <div className={this.state.isSafari ? "" : "row"}
                                      >
                                        <div className="col-sm-5"></div>
                                        <div
                                          className="col-sm-2"
                                          style={{
                                            marginBottom: "2vw",
                                          }}
                                          Align="center"
                                        >
                                          <h1 className="m-0 page-title">
                                            {this.state.updatingFolder ? "Update Folder" : "Add Folder"}
                                          </h1>
                                        </div>
                                        <div className="col-sm-5"></div>
                                      </div>
                                      <div style={{
                                        display: "flex",
                                        marginLeft: this.state.isSafari ? "-40vw" : "",
                                      }}>
                                        <div>
                                          <div
                                            className="form-group row"
                                            style={{ width: "40vw", gap: "0rem " }}
                                          >
                                            <label
                                              className="col-sm-3 col-form-label"
                                              Align="left"
                                              style={{ paddingLeft: "40px" }}
                                            >
                                              Folder Name
                                            </label>
                                            <div className="col-sm-8">
                                              <input
                                                type="text"
                                                name="childName"
                                                style={{ borderWidth: "1px" }}
                                                className="form-control-plaintext"
                                                id="labelId"
                                              // onChange={this.handleChangeForInputData}
                                              // onBlur={this.validateNameOfDomain}
                                              />
                                            </div>
                                          </div>
                                          <div>
                                            {/* <span className="errorMsg" style={{ color: 'red' }}>{this.state.errors.name} </span> */}
                                          </div>
                                          <br />
                                          <div className="form-group row">
                                            <label
                                              className="col-sm-3 col-form-label"
                                              Align="left"
                                              style={{ paddingLeft: "40px" }}
                                            >
                                              Folder Description
                                            </label>
                                            <div className="col-sm-8">
                                              <textarea
                                                type="text"
                                                name="childDescription"
                                                id="descriptionId"
                                                className="form-control"
                                                style={{
                                                  borderColor:
                                                    "rgba(192,192,192,0.3)",
                                                  borderWidth: "1px",
                                                }}
                                              // onBlur={this.validateDescOfDomain}
                                              // onChange={this.handleChangeForInputData}
                                              />
                                            </div>
                                          </div>
                                          <div>
                                            {/* <span className="errorMsg" style={{ color: 'red' }}>{this.state.errors.description} </span> */}
                                          </div>
                                        </div>
                                        <div>
                                          <img
                                            src={
                                              "data:image/png;base64," +
                                              this.state.iconFileNameDisplay
                                            }
                                            style={{
                                              height: "70px",
                                              width: "70px",
                                              borderColor: "transparent",
                                              display: this.state.iconImage
                                                ? "block"
                                                : "none",
                                            }}
                                          />
                                        </div>
                                      </div>

                                      <br />
                                      <div className={this.state.isSafari ? "form-group" : "row form-group"}>
                                        <label
                                          className="col-sm-3 col-form-label"
                                          Align="left"
                                          // Align={this.state.isSafari ? "" : "left"}
                                          style={{ paddingLeft: "40px" }}
                                        >
                                          Add/Change Icon
                                        </label>
                                        <div className="col-sm-4"
                                          Align={this.state.isSafari ? "" : "left"}>
                                          <FileChooser
                                            id="selectedMediaContent"
                                            name="bot-icon-input"
                                            accept="image/x-png,image/gif,image/jpeg"
                                            onChange={this.onChangeIconFile}
                                            fileName={(this.state.iconFile && this.state.iconFile.name) || this.state.iconFileName}
                                          />
                                          <h6 style={{ fontSize: "0.9rem", color: "#8c8788" }}>Supported file formats are JPG, JPEG, PNG, and GIF.</h6>

                                          {/* <input id="selectedMediaContent"
                                                                                        type="file"
                                                                                        ref={this.fileInput}
                                                                                        onChange={this.readFile}
                                                                                        style={{ display: "none" }} />
                                                                                    <button onClick={(e) => this.handleSubmit(e)}
                                                                                        style={{
                                                                                            width: "10rem",
                                                                                            height: "3rem",
                                                                                            fontSize: "1rem",
                                                                                            color: "white",
                                                                                            backgroundColor: "#282a65",
                                                                                            borderRadius: '10px',
                                                                                            border: 'none'
                                                                                        }}>
                                                                                        Choose Icon
                                                                                    </button> */}
                                        </div>
                                        <div className="col-sm-4" align="right">
                                          <button
                                            type="button"
                                            style={{
                                              fontSize: "1rem",
                                              backgroundColor: this.state.disableUpload && "#666e77",
                                              borderColor: this.state.disableUpload && "#666e77"
                                            }}
                                            id="contentUploadButton"
                                            className="btn btn-primary navyblue-btn mx-auto"
                                            data-dismiss="modal"
                                            disabled={this.state.disableUpload}
                                            //onClick={() => this.uploadMediaContent()}>
                                            onClick={() =>
                                              this.state.updatingFolder
                                                ? this.updateFolder()
                                                : this.saveFolder()
                                            }
                                          >
                                            Save
                                          </button>
                                        </div>
                                      </div>

                                      <div className="modal-footer noBorder"></div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* ------------- ADD CONTENT -----------               */}
                            <div
                              className="modal"
                              style={{
                                display: this.state.showAddContentOverLay
                                  ? "block"
                                  : "none",
                              }}
                            >
                              <div
                                className="modal-dialog"
                                id="center-aligned-account-modal"
                              >
                                <div
                                  className="modal-content"
                                  style={{
                                    position: "absolute",
                                    transform: "translate(7%, -7%)",
                                    height: "auto",
                                    width: "48vw",
                                    marginTop: "15vh",
                                  }}
                                  Align="center"
                                >
                                  {!this.state.isSafari &&
                                    <div className="modal-header noBorder">
                                      <button
                                        type="button"
                                        data-dismiss="modal"
                                        className="close"
                                        style={{ marginLeft: this.state.isSafari ? '40vw' : '' }}
                                        id="close_id"
                                        onClick={() =>
                                          this.closeAddContentOverLay()
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                        >
                                          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                          <path d="M0 0h24v24H0z" fill="none" />
                                        </svg>
                                      </button>
                                    </div>
                                  }
                                  {this.state.isSafari &&
                                    <button type="button"
                                      className="close"
                                      style={{ color: "#282a65", marginLeft: "40vw" }}
                                      onClick={() =>
                                        this.closeAddContentOverLay()
                                      }
                                    >
                                      <span>&times;</span>
                                    </button>
                                  }



                                  <div className="modal-body">
                                    <form
                                      ref={(el) => (this.childFormRef = el)}
                                    >
                                      <span
                                        className="errorMsg"
                                        style={{
                                          color: "red",
                                          fontSize: "18px",
                                          fontWeight: "400",
                                        }}
                                      >
                                        {this.state.errorMsg}
                                      </span>

                                      <div className=
                                        {this.state.isSafari ? "" : "row"}
                                      >
                                        <div
                                          className="col-sm-4"
                                          style={{
                                            marginTop: "1vw",
                                            display: this.state
                                              .disableSelectContentType
                                              ? "none"
                                              : "block",
                                          }}
                                        >
                                          <h1 className="m-0 page-title">
                                            Add Content
                                          </h1>
                                        </div>
                                        <div
                                          className="col-sm-4"
                                          style={{
                                            marginTop: "1vw",
                                            display: this.state
                                              .disableSelectContentType
                                              ? "block"
                                              : "none",
                                          }}
                                        >
                                          <h1 className="m-0 page-title">
                                            Update Content
                                          </h1>
                                          <br />
                                          <br />
                                          <br />
                                        </div>
                                        <div
                                          className="col-sm-8"
                                          align="right"
                                          style={{
                                            color: "black",
                                            display: this.state
                                              .disableSelectContentType
                                              ? "none"
                                              : "block",
                                          }}
                                        >
                                          <label>Select Content Type</label>
                                          <select
                                            id="contentTypeId"
                                            onChange={this.onContentTypeChange}
                                            style={{
                                              marginTop: "2vw",
                                              marginBottom: "2vw",
                                              height: "30px",
                                              borderRadius: "4px",
                                              backgroundColor: "#F9F9FB",
                                              width: "13vw",
                                              marginLeft: "10px",
                                            }}
                                          >
                                            <option value="TEXT">Text</option>
                                            <option value="IMAGE">Image</option>
                                            <option value="VIDEO">Video</option>
                                            <option value="AUDIO">Audio</option>
                                          </select>
                                        </div>
                                      </div>

                                      <div
                                        className={this.state.isSafari ? "" : "row"}
                                        style={{ justifyContent: "center" }}
                                      >
                                        <div
                                          className="form-group row"
                                          style={{
                                            display: this.state.textContentType
                                              ? "block"
                                              : "none",
                                          }}
                                        >
                                          <Editor
                                            id="contentId"
                                            editorState={editorState}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor editorClassName"
                                            onEditorStateChange={
                                              this.onEditorStateChange
                                            }
                                            placeholder="Please click here to start typing"
                                            spellCheck
                                            //  editorStyle={{
                                            //   marginTop: "1vw",
                                            //   minHeight: "190px",
                                            //   border: "1px solid #0094c8",
                                            //   padding: "6px",
                                            //   borderRadius: "5px",
                                            //   // cursor: "text",
                                            // }}
                                            toolbar={{
                                              options: [
                                                "inline",
                                                "blockType",
                                                "fontSize",
                                                "fontFamily",
                                                "list",
                                                "textAlign",
                                                "colorPicker",
                                                "link",
                                                "embedded",
                                                "remove",
                                                "history",
                                              ],

                                              inline: {
                                                inDropdown: true,
                                                options: [
                                                  "bold",
                                                  "italic",
                                                  "underline",
                                                  "strikethrough",
                                                  "monospace",
                                                  "superscript",
                                                  "subscript",
                                                ],
                                              },
                                              blockType: { inDropdown: true },
                                              fontSize: { inDropdown: true },
                                              fontFamily: { inDropdown: true },
                                              list: { inDropdown: true },
                                              textAlign: { inDropdown: true },
                                              colorPicker: { inDropdown: true },
                                              link: { inDropdown: true },
                                              embedded: { inDropdown: true },
                                              remove: { inDropdown: true },
                                              history: { inDropdown: true },
                                            }}
                                            // The built-in "emoji" option offers only 129 emojis
                                            toolbarCustomButtons={[<EmojiPickerButton />]}
                                          />
                                          {/* <Editor
                                            editorState={editorState}
                                            toolbarClassName="toolbarClassName"
                                            wrapperClassName="wrapperClassName"
                                            editorClassName="editorClassName"
                                            onEditorStateChange={this.onEditorStateChange}
                                            editorStyle={{
                                              marginTop: "1vw",
                                              minHeight: "190px",
                                              border: "1px solid #0094c8",
                                              padding: "6px",
                                              borderRadius: "5px",
                                              // cursor: "text",
                                            }}
                                            mention={{
                                              separator: " ",
                                              trigger: "@",
                                              suggestions: [
                                                { text: "APPLE", value: "apple" },
                                                { text: "BANANA", value: "banana", url: "banana" },
                                                { text: "CHERRY", value: "cherry", url: "cherry" },
                                                { text: "DURIAN", value: "durian", url: "durian" },
                                                { text: "EGGFRUIT", value: "eggfruit", url: "eggfruit" },
                                                { text: "FIG", value: "fig", url: "fig" },
                                                { text: "GRAPEFRUIT", value: "grapefruit", url: "grapefruit" },
                                                { text: "HONEYDEW", value: "honeydew", url: "honeydew" }
                                              ]
                                            }}
                                          /> */}
                                          <div className={this.state.isSafari ? "" : "row"}>
                                            <div className="col-sm-8"></div>
                                            <div
                                              className="col-sm-4"
                                              align="right"
                                            >
                                              <button
                                                type="button"
                                                style={{
                                                  fontSize: "1rem",
                                                  display: this.state
                                                    .disableDone
                                                    ? "none"
                                                    : "block",
                                                  float: "right",
                                                }}
                                                className="btn btn-primary navyblue-btn mx-auto"
                                                data-dismiss="modal"
                                                onClick={() =>
                                                  this.uploadMediaContent()
                                                }
                                              >
                                                {/* onClick={() =>
                                                                                                    this.state.updatingContent ? this.updateTextContent() : this.saveContent()}> */}
                                                Done
                                              </button>
                                            </div>
                                          </div>
                                        </div>

                                        <div
                                          className="form-group row"
                                          style={{
                                            width: "100%",
                                            display: this.state.imageContentType
                                              ? "block"
                                              : "none",
                                          }}
                                        >
                                          {!this.state.isSafari ?
                                            <div className="row">
                                              <div className="col-sm-1"></div>
                                              <div
                                                className="col-sm-3"

                                                Align="left"
                                              >
                                                <label style={{ color: "black" }}>
                                                  <input
                                                    style={{ marginRight: "1vw" }}
                                                    type="radio"
                                                    value="uploadFileContent"
                                                    checked={
                                                      this.state
                                                        .selectedOption ===
                                                      "uploadFileContent"
                                                    }
                                                    onChange={(event) =>
                                                      this.onChangeRadioButton(
                                                        event
                                                      )
                                                    }
                                                  />
                                                  Upload Image File
                                                </label>
                                              </div>
                                              <div
                                                className="col-sm-3"
                                                Align="left"
                                              >
                                                <label style={{ color: "black" }}>
                                                  <input
                                                    style={{ marginRight: "1vw" }}
                                                    type="radio"
                                                    value="uploadURLContent"
                                                    checked={
                                                      this.state
                                                        .selectedOption ===
                                                      "uploadURLContent"
                                                    }
                                                    onChange={(event) =>
                                                      this.onChangeRadioButton(
                                                        event
                                                      )
                                                    }
                                                  />
                                                  Enter Image URL
                                                </label>
                                              </div>
                                              <div className="col-sm-4"></div>
                                            </div>

                                            :
                                            <div

                                            // className="row"

                                            >
                                              {/* <div className="col-sm-1"></div> */}
                                              <div
                                                className="col-sm-3"

                                              // Align="left"
                                              >
                                                <label style={{ color: "black" }}>
                                                  <input
                                                    style={{ marginRight: "1vw" }}
                                                    type="radio"
                                                    value="uploadFileContent"
                                                    checked={
                                                      this.state
                                                        .selectedOption ===
                                                      "uploadFileContent"
                                                    }
                                                    onChange={(event) =>
                                                      this.onChangeRadioButton(
                                                        event
                                                      )
                                                    }
                                                  />
                                                  Upload Image File
                                                </label>
                                              </div>
                                              <div
                                                className="col-sm-3"
                                              // Align="left"
                                              >
                                                <label style={{ color: "black" }}>
                                                  <input
                                                    style={{ marginRight: "1vw" }}
                                                    type="radio"
                                                    value="uploadURLContent"
                                                    checked={
                                                      this.state
                                                        .selectedOption ===
                                                      "uploadURLContent"
                                                    }
                                                    onChange={(event) =>
                                                      this.onChangeRadioButton(
                                                        event
                                                      )
                                                    }
                                                  />
                                                  Enter Image URL
                                                </label>
                                              </div>
                                              <div className="col-sm-4"></div>
                                            </div>

                                          }

                                          {!this.state.isSafari ?
                                            <div
                                              style={{
                                                marginTop: "3vw",
                                                display: this.state
                                                  .uploadURLContent
                                                  ? "none"
                                                  : "block",
                                              }}
                                            >
                                              <div className={this.state.isSafari ? "" : "row"}>
                                                <div className="col-sm-2"></div>

                                                <div
                                                  className="col-sm-3"
                                                  Align="left"
                                                >
                                                  <label>Caption</label>
                                                </div>

                                                <div className="col-sm-4">
                                                  <input
                                                    type="text"
                                                    name="childName"
                                                    style={{ width: "92%" }}
                                                    className="form-control-plaintext"
                                                    id="imageCaptionId"
                                                  />
                                                </div>
                                                <div className="col-sm-3"></div>
                                              </div>
                                              <div
                                                className={this.state.isSafari ? "" : "row"}
                                                style={{ marginTop: "2vw" }}
                                              >
                                                <div className="col-sm-2"></div>

                                                <div
                                                  className="col-sm-3"
                                                  Align="left"
                                                >
                                                  <label>Upload Image</label>
                                                </div>

                                                <div
                                                  className="col-sm-4"
                                                  Align="left"
                                                >
                                                  <input
                                                    id="imageContentId"
                                                    type="file"
                                                    name="bot-icon-input"
                                                    // value={this.state.imgContent}
                                                    accept="image/x-png,image/gif,image/jpeg"
                                                    // disabled={!this.state.editable}
                                                    onChange={(event) =>
                                                      this.onFileContentChange(
                                                        event
                                                      )
                                                    }
                                                  />
                                                  <h6 style={{ fontSize: "0.9rem", color: "#8c8788" }}>Supported file formats are JPG, JPEG, PNG, and GIF.</h6>
                                                </div>
                                                <div className="col-sm-3"></div>
                                              </div>
                                              <div className={this.state.isSafari ? "" : "row"}>
                                                <div className="col-sm-8"></div>
                                                <div
                                                  className="col-sm-4"
                                                  align="right"
                                                >
                                                  <button
                                                    type="button"
                                                    style={{
                                                      marginTop: "3vw",
                                                      fontSize: "1rem",
                                                      display: this.state
                                                        .disableDone
                                                        ? "none"
                                                        : "",
                                                      float: "right",
                                                    }}
                                                    className="btn btn-primary navyblue-btn mx-auto"
                                                    data-dismiss="modal"
                                                    onClick={() =>
                                                      this.uploadMediaContent()
                                                    }
                                                  >
                                                    {/* onClick={(event) => this.state.updatingContent ?
                                                                                                        this.updateMediaContent(event) :
                                                                                                        this.onFileContentUploadApi(event)}> */}
                                                    Done
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                            :
                                            <div
                                              style={{
                                                marginTop: "10vw",
                                                display: this.state
                                                  .uploadURLContent
                                                  ? "none"
                                                  : "block",
                                              }}
                                            >
                                              <div
                                                style={{ display: "flex" }}
                                              >
                                                {/* <div className="col-sm-2"></div> */}

                                                <div
                                                  // className="col-sm-3"
                                                  // Align="left"
                                                  style={{ marginLeft: "7vw" }}
                                                >
                                                  <label>Caption</label>
                                                </div>

                                                <div
                                                  // className="col-sm-4"
                                                  style={{ marginLeft: "4vw" }}
                                                >
                                                  <input
                                                    type="text"
                                                    name="childName"
                                                    style={{ width: "92%" }}
                                                    className="form-control-plaintext"
                                                    id="imageCaptionId"
                                                  />
                                                </div>
                                                <div className="col-sm-3"></div>
                                              </div>
                                              <div
                                                // className={this.state.isSafari ? "" : "row"}
                                                style={{ marginTop: "2vw", display: "flex" }}
                                              >
                                                <div className="col-sm-2"></div>

                                                <div
                                                // className="col-sm-3"
                                                // Align="left"
                                                // style={{ marginLeft: "4vw" }}
                                                >
                                                  <label>Upload Image</label>
                                                </div>

                                                <div
                                                  // className="col-sm-4"
                                                  // Align="left"
                                                  style={{ marginLeft: "4vw" }}
                                                >
                                                  <input
                                                    id="imageContentId"
                                                    type="file"
                                                    name="bot-icon-input"
                                                    // value={this.state.imgContent}
                                                    accept="image/x-png,image/gif,image/jpeg"
                                                    // disabled={!this.state.editable}
                                                    onChange={(event) =>
                                                      this.onFileContentChange(
                                                        event
                                                      )
                                                    }
                                                  />
                                                  <h6 style={{ fontSize: "0.9rem", color: "#8c8788" }}>Supported file formats are JPG, JPEG, PNG, and GIF.</h6>
                                                </div>
                                                <div className="col-sm-3"></div>
                                              </div>
                                              <div className={this.state.isSafari ? "" : "row"}>
                                                <div className="col-sm-8"></div>
                                                <div
                                                  className="col-sm-4"
                                                  align="right"
                                                >
                                                  <button
                                                    type="button"
                                                    style={{
                                                      marginTop: "3vw",
                                                      fontSize: "1rem",
                                                      display: this.state
                                                        .disableDone
                                                        ? "none"
                                                        : "",
                                                      float: "right",
                                                    }}
                                                    className="btn btn-primary navyblue-btn mx-auto"
                                                    data-dismiss="modal"
                                                    onClick={() =>
                                                      this.uploadMediaContent()
                                                    }
                                                  >
                                                    {/* onClick={(event) => this.state.updatingContent ?
                                                                                                        this.updateMediaContent(event) :
                                                                                                        this.onFileContentUploadApi(event)}> */}
                                                    Done
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                          }

                                          {!this.state.isSafari ?
                                            <div
                                              className="row"
                                              style={{
                                                marginTop: "3vw",
                                                display: this.state
                                                  .uploadURLContent
                                                  ? "block"
                                                  : "none",
                                              }}
                                            >
                                              <div className="row">
                                                <div className="col-sm-2"></div>

                                                <div
                                                  className="col-sm-3"
                                                  Align={this.state.isSafari ? "" : "left"}
                                                >
                                                  <label>Caption</label>
                                                </div>

                                                <div className="col-sm-4">
                                                  <input
                                                    type="text"
                                                    name="childName"
                                                    style={{ width: "92%" }}
                                                    className="form-control-plaintext"
                                                    id="imageUrlCaptionId"
                                                  />
                                                </div>
                                                <div className="col-sm-3"></div>
                                              </div>
                                              <div
                                                className="row"
                                                style={{ marginTop: "3vw" }}
                                              >
                                                <div className="col-sm-2"></div>
                                                <div
                                                  className="col-sm-3"
                                                  Align="left"
                                                >
                                                  <label>Enter Image URL</label>
                                                </div>
                                                <div
                                                  className="col-sm-4"
                                                  Align="left"
                                                >
                                                  <input
                                                    type="text"
                                                    name="childName"
                                                    style={{ width: "92%" }}
                                                    className="form-control-plaintext"
                                                    id="imageContentUrl"
                                                    onChange={() =>
                                                      this.imageUrl()
                                                    }
                                                  />
                                                </div>
                                                <div className="col-sm-3"></div>
                                              </div>
                                              <div className={this.state.isSafari ? "" : "row"}>
                                                <div className="col-sm-8"></div>
                                                <div
                                                  className="col-sm-4"
                                                  align="right"
                                                >
                                                  <button
                                                    type="button"
                                                    style={{
                                                      marginTop: "3vw",
                                                      fontSize: "1rem",
                                                      display: this.state
                                                        .disableDone
                                                        ? "none"
                                                        : "block",
                                                      float: "right",
                                                    }}
                                                    className="btn btn-primary navyblue-btn mx-auto"
                                                    data-dismiss="modal"
                                                    onClick={() =>
                                                      this.uploadMediaContent()
                                                    }
                                                  >
                                                    {/* onClick={(event) => this.state.updatingContent ?
                                                                                                        this.updateMediaContent(event) :
                                                                                                        this.saveContent(event)}> */}
                                                    Done
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                            :
                                            <div
                                              // className="row"
                                              style={{
                                                marginTop: "10vw",
                                                display: this.state
                                                  .uploadURLContent
                                                  ? "block"
                                                  : "none",
                                              }}
                                            >
                                              <div
                                                style={{ display: "flex", marginLeft: "9.7vw" }}
                                              >

                                                <div

                                                >
                                                  <label>Caption</label>
                                                </div>

                                                <div
                                                  style={{ marginLeft: "6vw" }}
                                                >
                                                  <input
                                                    type="text"
                                                    name="childName"
                                                    style={{ width: "92%" }}
                                                    className="form-control-plaintext"
                                                    id="imageUrlCaptionId"
                                                  />
                                                </div>
                                                <div className="col-sm-3"></div>
                                              </div>
                                              <div
                                                style={{ display: "flex", marginTop: "4vw" }}
                                              >
                                                <div className="col-sm-2"></div>
                                                <div
                                                  className="col-sm-3"
                                                >
                                                  <label>Enter Image URL</label>
                                                </div>
                                                <div
                                                  className="col-sm-4"
                                                  Align="left"
                                                >
                                                  <input
                                                    type="text"
                                                    name="childName"
                                                    style={{ width: "92%" }}
                                                    className="form-control-plaintext"
                                                    id="imageContentUrl"
                                                    onChange={() =>
                                                      this.imageUrl()
                                                    }
                                                  />
                                                </div>
                                                <div className="col-sm-3"></div>
                                              </div>
                                              <div className={this.state.isSafari ? "" : "row"}>
                                                <div className="col-sm-8"></div>
                                                <div
                                                  className="col-sm-4"
                                                  align="right"
                                                >
                                                  <button
                                                    type="button"
                                                    style={{
                                                      marginTop: "3vw",
                                                      fontSize: "1rem",
                                                      display: this.state
                                                        .disableDone
                                                        ? "none"
                                                        : "block",
                                                      float: "right",
                                                    }}
                                                    className="btn btn-primary navyblue-btn mx-auto"
                                                    data-dismiss="modal"
                                                    onClick={() =>
                                                      this.uploadMediaContent()
                                                    }
                                                  >
                                                    {/* onClick={(event) => this.state.updatingContent ?
                                                                                                        this.updateMediaContent(event) :
                                                                                                        this.saveContent(event)}> */}
                                                    Done
                                                  </button>
                                                </div>
                                              </div>
                                            </div>

                                          }

                                        </div>
                                        <div
                                          className="form-group row"
                                          style={{
                                            width: "100%",
                                            display: this.state.videoContentType
                                              ? "block"
                                              : "none",
                                          }}
                                        >
                                          {!this.state.isSafari &&
                                            <div className="row">
                                              <div className="col-sm-1"></div>
                                              <div
                                                className="col-sm-3"
                                                Align="left"
                                              >
                                                <label style={{ color: "black" }}>
                                                  <input
                                                    style={{ marginRight: "1vw" }}
                                                    type="radio"
                                                    value="uploadFileContent"
                                                    checked={
                                                      this.state
                                                        .selectedOption ===
                                                      "uploadFileContent"
                                                    }
                                                    onChange={(event) =>
                                                      this.onChangeRadioButton(
                                                        event
                                                      )
                                                    }
                                                  />
                                                  Upload Video File
                                                </label>
                                              </div>
                                              <div
                                                className="col-sm-3"
                                                Align="left"
                                              >
                                                <label style={{ color: "black" }}>
                                                  <input
                                                    style={{ marginRight: "1vw" }}
                                                    type="radio"
                                                    Align="left"
                                                    value="uploadURLContent"
                                                    checked={
                                                      this.state
                                                        .selectedOption ===
                                                      "uploadURLContent"
                                                    }
                                                    onChange={(event) =>
                                                      this.onChangeRadioButton(
                                                        event
                                                      )
                                                    }
                                                  />
                                                  Enter Video URL
                                                </label>
                                              </div>
                                              <div className="col-sm-4"></div>
                                            </div>
                                          }
                                          {this.state.isSafari &&
                                            <div

                                            // className="row"
                                            >
                                              {/* <div className="col-sm-1"></div> */}
                                              <div
                                                className="col-sm-3"
                                              // Align={this.state.isSafari ? "" : "left"}
                                              >
                                                <label style={{ color: "black" }}>
                                                  <input
                                                    style={{ marginRight: "1vw" }}
                                                    type="radio"
                                                    value="uploadFileContent"
                                                    checked={
                                                      this.state
                                                        .selectedOption ===
                                                      "uploadFileContent"
                                                    }
                                                    onChange={(event) =>
                                                      this.onChangeRadioButton(
                                                        event
                                                      )
                                                    }
                                                  />
                                                  Upload Video File
                                                </label>
                                              </div>
                                              <div
                                                className="col-sm-3"
                                              // Align={this.state.isSafari ? "" : "left"}
                                              >
                                                <label style={{ color: "black" }}>
                                                  <input
                                                    style={{ marginRight: "1vw" }}
                                                    type="radio"
                                                    Align="left"
                                                    value="uploadURLContent"
                                                    checked={
                                                      this.state
                                                        .selectedOption ===
                                                      "uploadURLContent"
                                                    }
                                                    onChange={(event) =>
                                                      this.onChangeRadioButton(
                                                        event
                                                      )
                                                    }
                                                  />
                                                  Enter Video URL
                                                </label>
                                              </div>
                                              <div className="col-sm-4"></div>
                                            </div>
                                          }

                                          {!this.state.isSafari ?
                                            <div
                                              className="row"
                                              style={{
                                                marginTop: "3vw",
                                                display: this.state
                                                  .uploadURLContent
                                                  ? "none"
                                                  : "block",
                                              }}
                                            >
                                              <div className="row">
                                                <div className="col-sm-2"></div>

                                                <div
                                                  className="col-sm-3"
                                                  Align="left"
                                                >
                                                  <label>Caption</label>
                                                </div>

                                                <div className="col-sm-4">
                                                  <input
                                                    type="text"
                                                    name="childName"
                                                    style={{ width: "92%" }}
                                                    className="form-control-plaintext"
                                                    id="videoCaptionId"
                                                  />
                                                </div>
                                                <div className="col-sm-3"></div>
                                              </div>
                                              <div
                                                className={this.state.isSafari ? "" : "row"}
                                                style={{ marginTop: "2vw", display: "flex" }}
                                              >
                                                {/* <div className="col-sm-2"></div> */}

                                                <div
                                                  className="col-sm-3"
                                                  Align="left"
                                                  style={{ marginLeft: "4vw" }}
                                                >
                                                  <label>Upload Video</label>
                                                </div>

                                                <div
                                                  className="col-sm-4"
                                                  Align="left"
                                                  style={{ marginLeft: "2vw" }}

                                                >
                                                  <input
                                                    id="videoContentId"
                                                    type="file"
                                                    name="bot-icon-input"
                                                    accept="image/x-png,image/gif,image/jpeg"
                                                    // disabled={!this.state.editable}
                                                    onChange={(event) =>
                                                      this.onFileContentChange(
                                                        event
                                                      )
                                                    }
                                                  />
                                                  <h6 style={{ fontSize: "0.9rem", color: "#8c8788" }}>Supported file formats are mp4, mov, avi.</h6>
                                                  <Progress
                                                    style={{
                                                      display: this.state
                                                        .showProgressBar
                                                        ? "block"
                                                        : "none",
                                                      marginTop: "2vw",
                                                      width: "20vw",
                                                    }}
                                                    id="build"
                                                    width="500px"
                                                    height="50px"
                                                    rectBorderRadius="1px"
                                                    status={
                                                      this.state.progressStatus
                                                    }
                                                    percent={
                                                      this.state.percentage
                                                    }
                                                  />
                                                </div>
                                                <div className="col-sm-3"></div>
                                              </div>
                                            </div> :

                                            <div
                                              // className="row"
                                              style={{
                                                marginTop: "10vw",
                                                display: this.state
                                                  .uploadURLContent
                                                  ? "none"
                                                  : "block",
                                              }}
                                            >
                                              <div
                                                // className="row"
                                                style={{ display: "flex" }}
                                              >
                                                {/* <div className="col-sm-2"></div> */}

                                                <div
                                                  // className="col-sm-3"
                                                  // Align="left"
                                                  style={{ marginLeft: "7vw" }}

                                                >
                                                  <label>Caption</label>
                                                </div>

                                                <div
                                                  //  className="col-sm-4"
                                                  style={{ marginLeft: "4vw" }}
                                                >
                                                  <input
                                                    type="text"
                                                    name="childName"
                                                    style={{ width: "92%" }}
                                                    className="form-control-plaintext"
                                                    id="videoCaptionId"
                                                  />
                                                </div>
                                                <div className="col-sm-3"></div>
                                              </div>
                                              <div
                                                // className={this.state.isSafari ? "" : "row"}
                                                style={{ marginTop: "2vw", display: "flex" }}
                                              >
                                                {/* <div className="col-sm-2"></div> */}

                                                <div
                                                  // className="col-sm-3"
                                                  // Align="left"
                                                  style={{ marginLeft: "7vw" }}

                                                >
                                                  <label>Upload Video</label>
                                                </div>

                                                <div
                                                  // className="col-sm-4"
                                                  // Align="left"
                                                  style={{ marginLeft: "4vw" }}
                                                >
                                                  <input
                                                    id="videoContentId"
                                                    type="file"
                                                    name="bot-icon-input"
                                                    accept="image/x-png,image/gif,image/jpeg"
                                                    // disabled={!this.state.editable}
                                                    onChange={(event) =>
                                                      this.onFileContentChange(
                                                        event
                                                      )
                                                    }
                                                  />
                                                  <h6 style={{ fontSize: "0.9rem", color: "#8c8788" }}>Supported file formats are mp4, mov, avi.</h6>

                                                  <Progress
                                                    style={{
                                                      display: this.state
                                                        .showProgressBar
                                                        ? "block"
                                                        : "none",
                                                      marginTop: "2vw",
                                                      width: "20vw",
                                                    }}
                                                    id="build"
                                                    width="500px"
                                                    height="50px"
                                                    rectBorderRadius="1px"
                                                    status={
                                                      this.state.progressStatus
                                                    }
                                                    percent={
                                                      this.state.percentage
                                                    }
                                                  />
                                                </div>
                                                <div className="col-sm-3"></div>
                                              </div>
                                            </div>

                                          }

                                          {!this.state.isSafari ?

                                            <div
                                              className="row"
                                              style={{
                                                marginTop: "3vw",
                                                display: this.state
                                                  .uploadURLContent
                                                  ? "block"
                                                  : "none",
                                              }}
                                            >
                                              <div className="row">
                                                <div className="col-sm-2"></div>

                                                <div
                                                  className="col-sm-3"
                                                  Align={this.state.isSafari ? "" : "left"}
                                                >
                                                  <label>Caption</label>
                                                </div>

                                                <div className="col-sm-4">
                                                  <input
                                                    type="text"
                                                    name="childName"
                                                    style={{ width: "92%" }}
                                                    className="form-control-plaintext"
                                                    id="videoUrlCaptionId"
                                                  />
                                                </div>
                                                <div className="col-sm-3"></div>
                                              </div>
                                              <div
                                                className="row"
                                                style={{ marginTop: "3vw" }}
                                              >
                                                <div className="col-sm-2"></div>
                                                <div
                                                  className="col-sm-3"
                                                  Align="left"
                                                >
                                                  <label>Enter Video URL</label>
                                                </div>
                                                <div className="col-sm-4">
                                                  <input
                                                    type="text"
                                                    name="childName"
                                                    style={{ width: "92%" }}
                                                    className="form-control-plaintext"
                                                    id="videoContentUrl"
                                                    onChange={() =>
                                                      this.videoUrl()
                                                    }
                                                  />
                                                  <Progress
                                                    style={{
                                                      display: this.state
                                                        .showProgressBar
                                                        ? "block"
                                                        : "none",
                                                      marginTop: "2vw",
                                                      width: "20vw",
                                                    }}
                                                    id="build"
                                                    width="500px"
                                                    height="50px"
                                                    rectBorderRadius="1px"
                                                    status={
                                                      this.state.progressStatus
                                                    }
                                                    percent={
                                                      this.state.percentage
                                                    }
                                                  />
                                                </div>
                                                <div className="col-sm-3"></div>
                                              </div>
                                            </div>
                                            :
                                            <div
                                              style={{
                                                marginTop: "10vw",
                                                display: this.state
                                                  .uploadURLContent
                                                  ? "block"
                                                  : "none",
                                              }}
                                            >
                                              <div

                                                style={{ display: "flex", marginLeft: "9.7vw" }}
                                              >
                                                {/* <div className="col-sm-2"></div> */}

                                                <div
                                                // className="col-sm-3"
                                                >
                                                  <label>Caption</label>
                                                </div>

                                                <div
                                                  style={{ marginLeft: "6vw" }}

                                                // className="col-sm-4"
                                                >
                                                  <input
                                                    type="text"
                                                    name="childName"
                                                    style={{ width: "92%" }}
                                                    className="form-control-plaintext"
                                                    id="videoUrlCaptionId"
                                                  />
                                                </div>
                                                <div className="col-sm-3"></div>
                                              </div>
                                              <div style={{ display: "flex", marginTop: "4vw" }}
                                              // className="row"
                                              >
                                                <div className="col-sm-2"></div>
                                                <div
                                                  className="col-sm-3"
                                                // Align="left"
                                                >
                                                  <label>Enter Video URL</label>
                                                </div>
                                                <div className="col-sm-4">
                                                  <input
                                                    type="text"
                                                    name="childName"
                                                    style={{ width: "92%" }}
                                                    className="form-control-plaintext"
                                                    id="videoContentUrl"
                                                    onChange={() =>
                                                      this.videoUrl()
                                                    }
                                                  />
                                                  <Progress
                                                    style={{
                                                      display: this.state
                                                        .showProgressBar
                                                        ? "block"
                                                        : "none",
                                                      marginTop: "2vw",
                                                      width: "20vw",
                                                    }}
                                                    id="build"
                                                    width="500px"
                                                    height="50px"
                                                    rectBorderRadius="1px"
                                                    status={
                                                      this.state.progressStatus
                                                    }
                                                    percent={
                                                      this.state.percentage
                                                    }
                                                  />
                                                </div>
                                                <div className="col-sm-3"></div>
                                              </div>
                                            </div>

                                          }


                                          <div className={this.state.isSafari ? "" : "row"}>
                                            <div className="col-sm-8"></div>
                                            <div
                                              className="col-sm-4"
                                              align="right"
                                            >
                                              <button
                                                type="button"
                                                style={{
                                                  marginTop: "3vw",
                                                  fontSize: "1rem",
                                                  display: this.state
                                                    .disableDone
                                                    ? "none"
                                                    : "block",
                                                  float: "right",
                                                }}
                                                className="btn btn-primary navyblue-btn mx-auto"
                                                data-dismiss="modal"
                                                onClick={() =>
                                                  this.uploadMediaContent()
                                                }
                                              >
                                                {/* onClick={(event) => this.state.fileContentUpload ? this.onFileContentUploadApi(event) : this.saveContent(event)}> */}
                                                Done
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="form-group row"
                                          style={{
                                            width: "100%",
                                            display: this.state.audioContentType
                                              ? "block"
                                              : "none",
                                          }}
                                        >
                                          {!this.state.isSafari ?
                                            <div className="row">
                                              <div className="col-sm-1"></div>
                                              <div
                                                className="col-sm-3"
                                                Align="left"
                                              >
                                                <label style={{ color: "black" }}>
                                                  <input
                                                    style={{ marginRight: "1vw" }}
                                                    type="radio"
                                                    value="uploadFileContent"
                                                    checked={
                                                      this.state
                                                        .selectedOption ===
                                                      "uploadFileContent"
                                                    }
                                                    onChange={(event) =>
                                                      this.onChangeRadioButton(
                                                        event
                                                      )
                                                    }
                                                  />
                                                  Upload Audio File
                                                </label>
                                              </div>
                                              <div
                                                className="col-sm-3"
                                                Align="left"
                                              >
                                                <label style={{ color: "black" }}>
                                                  <input
                                                    style={{ marginRight: "1vw" }}
                                                    type="radio"
                                                    Align="left"
                                                    value="uploadURLContent"
                                                    checked={
                                                      this.state
                                                        .selectedOption ===
                                                      "uploadURLContent"
                                                    }
                                                    onChange={(event) =>
                                                      this.onChangeRadioButton(
                                                        event
                                                      )
                                                    }
                                                  />
                                                  Enter Audio URL
                                                </label>
                                              </div>
                                              <div className="col-sm-4"></div>
                                            </div>

                                            :
                                            <div
                                            // className="row"
                                            >
                                              <div
                                                className="col-sm-3"
                                              // Align= "left"
                                              >
                                                <label style={{ color: "black" }}>
                                                  <input
                                                    style={{ marginRight: "1vw" }}
                                                    type="radio"
                                                    value="uploadFileContent"
                                                    checked={
                                                      this.state
                                                        .selectedOption ===
                                                      "uploadFileContent"
                                                    }
                                                    onChange={(event) =>
                                                      this.onChangeRadioButton(
                                                        event
                                                      )
                                                    }
                                                  />
                                                  Upload Audio File
                                                </label>
                                              </div>
                                              <div
                                                className="col-sm-3"
                                              // Align= "left"
                                              >
                                                <label style={{ color: "black" }}>
                                                  <input
                                                    style={{ marginRight: "1vw" }}
                                                    type="radio"
                                                    Align="left"
                                                    value="uploadURLContent"
                                                    checked={
                                                      this.state
                                                        .selectedOption ===
                                                      "uploadURLContent"
                                                    }
                                                    onChange={(event) =>
                                                      this.onChangeRadioButton(
                                                        event
                                                      )
                                                    }
                                                  />
                                                  Enter Audio URL
                                                </label>
                                              </div>
                                              <div className="col-sm-4"></div>
                                            </div>

                                          }

                                          {!this.state.isSafari ?
                                            <div
                                              className="row"
                                              style={{
                                                marginTop: "3vw",
                                                display: this.state
                                                  .uploadURLContent
                                                  ? "none"
                                                  : "block",
                                              }}
                                            >
                                              <div className="row">
                                                <div className="col-sm-2"></div>

                                                <div
                                                  className="col-sm-3"
                                                  Align="left"
                                                >
                                                  <label>Caption</label>
                                                </div>

                                                <div className="col-sm-4">
                                                  <input
                                                    type="text"
                                                    name="childName"
                                                    style={{ width: "92%" }}
                                                    className="form-control-plaintext"
                                                    id="audioCaptionId"
                                                  />
                                                </div>
                                                <div className="col-sm-3"></div>
                                              </div>
                                              <div
                                                className="row"
                                                style={{ marginTop: "2vw" }}
                                              >
                                                <div className="col-sm-2"></div>

                                                <div
                                                  className="col-sm-3"
                                                  Align="left"
                                                >
                                                  <label>Upload Audio</label>
                                                </div>

                                                <div
                                                  className="col-sm-4"
                                                  Align="left"
                                                >
                                                  <input
                                                    id="audioContentId"
                                                    type="file"
                                                    name="bot-icon-input"
                                                    Align="left"
                                                    accept="image/x-png,image/gif,image/jpeg"
                                                    // disabled={!this.state.editable}
                                                    onChange={(event) =>
                                                      this.onFileContentChange(
                                                        event
                                                      )
                                                    }
                                                  />
                                                  <h6 style={{ fontSize: "0.9rem", color: "#8c8788" }}>Supported file formats are mp3, wav, ogg, mpeg.</h6>

                                                  <Progress
                                                    style={{
                                                      display: this.state
                                                        .showProgressBar
                                                        ? "block"
                                                        : "none",
                                                      marginTop: "2vw",
                                                      width: "20vw",
                                                    }}
                                                    id="build"
                                                    width="500px"
                                                    height="50px"
                                                    rectBorderRadius="1px"
                                                    status={
                                                      this.state.progressStatus
                                                    }
                                                    percent={
                                                      this.state.percentage
                                                    }
                                                  />
                                                </div>
                                                <div className="col-sm-3"></div>
                                              </div>
                                            </div>
                                            :
                                            <div
                                              // className="row"
                                              style={{
                                                marginTop: "10vw",
                                                display: this.state
                                                  .uploadURLContent
                                                  ? "none"
                                                  : "block",
                                              }}
                                            >
                                              <div
                                                style={{ display: "flex" }}
                                              >

                                                <div
                                                  // className="col-sm-3"
                                                  // Align="left"
                                                  style={{ marginLeft: "7vw" }}
                                                >
                                                  <label>Caption</label>
                                                </div>

                                                <div
                                                  // className="col-sm-4"
                                                  style={{ marginLeft: "4vw" }}
                                                >
                                                  <input
                                                    type="text"
                                                    name="childName"
                                                    style={{ width: "92%" }}
                                                    className="form-control-plaintext"
                                                    id="audioCaptionId"
                                                  />
                                                </div>
                                                {/* <div className="col-sm-3"></div> */}
                                              </div>
                                              <div
                                                // className={this.state.isSafari ? "" : "row"}
                                                style={{ marginTop: "2vw", display: "flex" }}
                                              >
                                                {/* <div className="col-sm-2"></div> */}

                                                <div
                                                  // className="col-sm-3"
                                                  // Align="left"
                                                  style={{ marginLeft: "7vw" }}
                                                >
                                                  <label>Upload Audio</label>
                                                </div>

                                                <div
                                                  // className="col-sm-4"
                                                  // Align="left"
                                                  style={{ marginLeft: "4vw" }}
                                                >
                                                  <input
                                                    id="audioContentId"
                                                    type="file"
                                                    name="bot-icon-input"
                                                    Align="left"
                                                    accept="image/x-png,image/gif,image/jpeg"
                                                    // disabled={!this.state.editable}
                                                    onChange={(event) =>
                                                      this.onFileContentChange(
                                                        event
                                                      )
                                                    }
                                                  />
                                                  <h6 style={{ fontSize: "0.9rem", color: "#8c8788" }}>Supported file formats are mp3, wav, ogg, mpeg.</h6>

                                                  <Progress
                                                    style={{
                                                      display: this.state
                                                        .showProgressBar
                                                        ? "block"
                                                        : "none",
                                                      marginTop: "2vw",
                                                      width: "20vw",
                                                    }}
                                                    id="build"
                                                    width="500px"
                                                    height="50px"
                                                    rectBorderRadius="1px"
                                                    status={
                                                      this.state.progressStatus
                                                    }
                                                    percent={
                                                      this.state.percentage
                                                    }
                                                  />
                                                </div>
                                                <div className="col-sm-3"></div>
                                              </div>
                                            </div>

                                          }

                                          {!this.state.isSafari ?
                                            <div
                                              className={this.state.isSafari ? "" : "row"}
                                              style={{
                                                marginTop: "3vw",
                                                display: this.state
                                                  .uploadURLContent
                                                  ? "block"
                                                  : "none",
                                              }}
                                            >
                                              <div className={this.state.isSafari ? "" : "row"}>
                                                <div className="col-sm-2"></div>

                                                <div
                                                  className="col-sm-3"
                                                  Align="left"
                                                >
                                                  <label>Caption</label>
                                                </div>

                                                <div className="col-sm-4">
                                                  <input
                                                    type="text"
                                                    name="childName"
                                                    style={{ width: "92%" }}
                                                    className="form-control-plaintext"
                                                    id="audioUrlCaptionId"
                                                  />
                                                </div>
                                                <div className="col-sm-3"></div>
                                              </div>
                                              <div
                                                className="row"
                                                style={{ marginTop: "3vw" }}
                                              >
                                                <div className="col-sm-2"></div>
                                                <div
                                                  className="col-sm-3"
                                                  Align="left"
                                                >
                                                  <label>Enter Audio URL</label>
                                                </div>
                                                <div className="col-sm-4">
                                                  <input
                                                    type="text"
                                                    name="childName"
                                                    style={{ width: "92%" }}
                                                    className="form-control-plaintext"
                                                    id="audioContentUrl"
                                                    Align="left"
                                                    onChange={() => {
                                                      this.audioUrl();
                                                    }}
                                                  />
                                                  <Progress
                                                    style={{
                                                      display: this.state
                                                        .showProgressBar
                                                        ? "block"
                                                        : "none",
                                                      marginTop: "2vw",
                                                      width: "20vw",
                                                    }}
                                                    id="build"
                                                    width="500px"
                                                    height="50px"
                                                    rectBorderRadius="1px"
                                                    status={
                                                      this.state.progressStatus
                                                    }
                                                    percent={
                                                      this.state.percentage
                                                    }
                                                  />
                                                </div>
                                                <div className="col-sm-3"></div>
                                              </div>
                                            </div>
                                            :
                                            <div
                                              // className="row"
                                              style={{
                                                marginTop: "10vw",
                                                display: this.state
                                                  .uploadURLContent
                                                  ? "block"
                                                  : "none",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "flex",
                                                  marginLeft: "2.7vw"

                                                }}
                                              >

                                                <div
                                                // className="col-sm-3"
                                                // Align="left"
                                                >
                                                  <label>Caption</label>
                                                </div>

                                                <div
                                                  // className="col-sm-4"
                                                  style={{ marginLeft: "6vw" }}
                                                >
                                                  <input
                                                    type="text"
                                                    name="childName"
                                                    style={{ width: "92%" }}
                                                    className="form-control-plaintext"
                                                    id="audioUrlCaptionId"
                                                  />
                                                </div>
                                                <div className="col-sm-3"></div>
                                              </div>
                                              <div
                                                // className="row"
                                                style={{ marginTop: "4vw", display: "flex", }}
                                              >
                                                {/* <div className="col-sm-2"></div> */}
                                                <div
                                                  className="col-sm-3"
                                                // Align="left"
                                                // style={{ marginLeft: "8vw" }}
                                                >
                                                  <label>Enter Audio URL</label>
                                                </div>
                                                <div

                                                  className="col-sm-4">
                                                  <input
                                                    type="text"
                                                    name="childName"
                                                    style={{ width: "92%" }}
                                                    className="form-control-plaintext"
                                                    id="audioContentUrl"
                                                    Align="left"
                                                    onChange={() => {
                                                      this.audioUrl();
                                                    }}
                                                  />
                                                  <Progress
                                                    style={{
                                                      display: this.state
                                                        .showProgressBar
                                                        ? "block"
                                                        : "none",
                                                      marginTop: "2vw",
                                                      width: "20vw",
                                                    }}
                                                    id="build"
                                                    width="500px"
                                                    height="50px"
                                                    rectBorderRadius="1px"
                                                    status={
                                                      this.state.progressStatus
                                                    }
                                                    percent={
                                                      this.state.percentage
                                                    }
                                                  />
                                                </div>
                                                <div className="col-sm-3"></div>
                                              </div>
                                            </div>

                                          }



                                          <div className={this.state.isSafari ? "" : "row"}>
                                            <div className="col-sm-8"></div>
                                            <div
                                              className="col-sm-4"
                                              align="right"
                                            >
                                              <button
                                                type="button"
                                                style={{
                                                  marginTop: "3vw",
                                                  fontSize: "1rem",
                                                  display: this.state
                                                    .disableDone
                                                    ? "none"
                                                    : "block",
                                                  float: "right",
                                                }}
                                                className="btn btn-primary navyblue-btn mx-auto"
                                                data-dismiss="modal"
                                                onClick={() =>
                                                  this.uploadMediaContent()
                                                }
                                              >
                                                {/* onClick={(event) => this.state.fileContentUpload ? this.onFileContentUploadApi(event) : this.saveContent(event)}> */}
                                                Done
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* ------------- Preview -----------               */}
                            <div
                              className="modal"
                              style={{
                                display: this.state.showpreviewModeOverLay
                                  ? "block"
                                  : "none",
                              }}
                            >
                              <div
                                className="modal-dialog"
                                id="center-aligned-account-modal"
                              >
                                <div
                                  className="modal-content"
                                  style={{
                                    position: "absolute",
                                    transform: "translate(7%, -7%)",
                                    height: "auto",
                                    width: "525px",
                                    marginTop: "15vh",
                                    marginLeft: "15vw",
                                  }}
                                  Align="center"
                                >
                                  {!this.state.isSafari &&
                                    <div className="modal-header noBorder">
                                      <button
                                        type="button"
                                        // className="close"
                                        className="close"
                                        style={{ marginLeft: this.state.isSafari ? '40vw' : '' }}
                                        data-dismiss="modal"
                                        id="close_id"
                                        // style={{ marginLeft: '40vw' }}

                                        onClick={() =>
                                          this.closepreviewModeOverLay()
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                        >
                                          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                          <path d="M0 0h24v24H0z" fill="none" />
                                        </svg>
                                      </button>
                                    </div>}
                                  {this.state.isSafari &&
                                    <button type="button"
                                      className="close"
                                      style={{ color: "#282a65", marginLeft: "32vw" }}
                                      onClick={() =>
                                        this.closepreviewModeOverLay()
                                      }
                                    >
                                      <span>&times;</span>
                                    </button>
                                  }
                                  <div
                                    style={{
                                      width: "483px",
                                      height: "1022px",
                                      paddingTop: "73px",
                                      paddingLeft: "26px",
                                      paddingRight: "26px",
                                      paddingBottom: "73px",
                                      backgroundImage:
                                        "url(/my-jeeva/assets/images/phoneOutline.png)",
                                    }}
                                  >
                                    <iframe
                                      style={{
                                        border: "none",
                                        height: "100%",
                                        width: "100%",
                                      }}
                                      src="/my-jeeva/app-content-preview"
                                      id="previewIframe"
                                    ></iframe>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/*-------------- Browsing Admin Content -------------*/}
                            {this.state.showBrowseModal && (
                              <div className="container">
                                <div
                                  className="modal"
                                  style={{
                                    display: this.state.showBrowseModal
                                      ? "block"
                                      : "none",
                                  }}
                                >
                                  <div
                                    className="modal-dialog"
                                    id="center-aligned-account-modal"
                                  >
                                    <div
                                      className="modal-content"
                                      style={{
                                        height: "80vh",
                                        width: "90vw",
                                        left: "-21rem",
                                      }}
                                    >
                                      <div className="modal-header noBorder">
                                        <div
                                          className="row"
                                          style={{ marginTop: "-30px" }}
                                        >
                                          <div style={{ marginLeft: "4.2rem" }}>
                                            <button className="btn action-button"
                                              onClick={
                                                this.handleBrowseModalClose
                                              }
                                            >
                                              Close
                                            </button>
                                            <button className="btn action-button"
                                              onClick={this.addNewAdminContent}
                                              disabled={this.checkForEmpty()}
                                            // style={{display: this.state.newAdminContent.size != 0? "block" : "none"}}
                                            >
                                              Copy Selected Content
                                            </button>
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        style={{
                                          display: "grid",
                                          gridTemplateColumns: "1fr 1fr",
                                          gap: "2rem",
                                        }}
                                      >

                                        <div
                                          className="modal-body"
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            marginTop: "1vh",
                                            display: "grid",
                                            height: "70vh",
                                            overflow: "scroll",
                                          }}
                                        >
                                          <div className="browse-item2">
                                            <BrowseContent
                                              userRole="Admin"
                                              handleAddContentData={
                                                this.handleAddContentData
                                              }
                                              handleChangeParentFolderId={
                                                this.handleChangeParentFolderId
                                              }
                                              handleRemoveContentData={this.handleRemoveContentData}
                                            />
                                          </div>
                                        </div>
                                        <div
                                          className="modal-body"
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            marginTop: "1vh",
                                            display: "grid",
                                            height: "70vh",
                                            overflow: "scroll",
                                          }}
                                        >
                                          <div className="browse-item1">
                                            <BrowseContent
                                              userRole="Provider"
                                              handleAddContentData={
                                                this.handleAddContentData
                                              }
                                              handleChangeParentFolderId={
                                                this.handleChangeParentFolderId
                                              }
                                              handleRemoveContentData={this.handleRemoveContentData}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ContentLibraryForTreatment.js